import _slicedToArray from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _taggedTemplateLiteral from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _categories, _crops, _td;

function _templateObject94() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  margin-top: 10px;\n  margin-right: 13px;\n"]);

  _templateObject94 = function _templateObject94() {
    return data;
  };

  return data;
}

function _templateObject93() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: space-between;\n  max-width: ", "px;\n"]);

  _templateObject93 = function _templateObject93() {
    return data;
  };

  return data;
}

function _templateObject92() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n"]);

  _templateObject92 = function _templateObject92() {
    return data;
  };

  return data;
}

function _templateObject91() {
  var data = _taggedTemplateLiteral(["\n  z-index: 5;\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n"]);

  _templateObject91 = function _templateObject91() {
    return data;
  };

  return data;
}

function _templateObject90() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  top: ", "px;\n  left: ", "px;\n  overflow: hidden;\n"]);

  _templateObject90 = function _templateObject90() {
    return data;
  };

  return data;
}

function _templateObject89() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-top: 2px dashed ", ";\n  background: transparent;\n  left: ", "px;\n  top: ", "px;\n  transform: rotate(", "rad);\n  width: 200%;\n"]);

  _templateObject89 = function _templateObject89() {
    return data;
  };

  return data;
}

function _templateObject88() {
  var data = _taggedTemplateLiteral(["\n      width: 2px;\n      height: 100%;\n      left: ", "px;\n    "]);

  _templateObject88 = function _templateObject88() {
    return data;
  };

  return data;
}

function _templateObject87() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n        height: 2px;\n        top: ", "px;\n      "]);

  _templateObject87 = function _templateObject87() {
    return data;
  };

  return data;
}

function _templateObject86() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  ", "\n"]);

  _templateObject86 = function _templateObject86() {
    return data;
  };

  return data;
}

function _templateObject85() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  z-index: ", ";\n"]);

  _templateObject85 = function _templateObject85() {
    return data;
  };

  return data;
}

function _templateObject84() {
  var data = _taggedTemplateLiteral(["\n          cursor: move;\n        "]);

  _templateObject84 = function _templateObject84() {
    return data;
  };

  return data;
}

function _templateObject83() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  z-index: ", ";\n"]);

  _templateObject83 = function _templateObject83() {
    return data;
  };

  return data;
}

function _templateObject82() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  transform: scale(0.9);\n"]);

  _templateObject82 = function _templateObject82() {
    return data;
  };

  return data;
}

function _templateObject81() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n"]);

  _templateObject81 = function _templateObject81() {
    return data;
  };

  return data;
}

function _templateObject80() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n"]);

  _templateObject80 = function _templateObject80() {
    return data;
  };

  return data;
}

function _templateObject79() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n"]);

  _templateObject79 = function _templateObject79() {
    return data;
  };

  return data;
}

function _templateObject78() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n  transform: scaleX(-1);\n"]);

  _templateObject78 = function _templateObject78() {
    return data;
  };

  return data;
}

function _templateObject77() {
  var data = _taggedTemplateLiteral(["\n  transform: translate(0, 0) !important;\n"]);

  _templateObject77 = function _templateObject77() {
    return data;
  };

  return data;
}

function _templateObject76() {
  var data = _taggedTemplateLiteral(["\n      display: inline-block;\n    "]);

  _templateObject76 = function _templateObject76() {
    return data;
  };

  return data;
}

function _templateObject75() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  display: none;\n  width: 33px;\n  text-align: right;\n  color: ", ";\n  z-index: 1;\n  margin: 2px;\n  ", "\n"]);

  _templateObject75 = function _templateObject75() {
    return data;
  };

  return data;
}

function _templateObject74() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-self: center;\n"]);

  _templateObject74 = function _templateObject74() {
    return data;
  };

  return data;
}

function _templateObject73() {
  var data = _taggedTemplateLiteral(["\n      display: inline-block;\n    "]);

  _templateObject73 = function _templateObject73() {
    return data;
  };

  return data;
}

function _templateObject72() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: none;\n  position: relative;\n  transform: unset !important;\n  vertical-align: bottom;\n  ", "\n"]);

  _templateObject72 = function _templateObject72() {
    return data;
  };

  return data;
}

function _templateObject71() {
  var data = _taggedTemplateLiteral(["\n    top: ", "px;\n    left: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      top: -30px;\n      left: 6px;\n    }\n  "]);

  _templateObject71 = function _templateObject71() {
    return data;
  };

  return data;
}

function _templateObject70() {
  var data = _taggedTemplateLiteral(["\n    left: ", "px;\n    top: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      left: -30px;\n      top: -30px;\n    }\n  "]);

  _templateObject70 = function _templateObject70() {
    return data;
  };

  return data;
}

function _templateObject69() {
  var data = _taggedTemplateLiteral(["\n    left: ", "px;\n    top: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      left: -30px;\n      top: 6px;\n    }\n  "]);

  _templateObject69 = function _templateObject69() {
    return data;
  };

  return data;
}

function _templateObject68() {
  var data = _taggedTemplateLiteral(["\n  left: ", "px;\n  top: ", "px;\n  @media all and (min-width: 0) and (max-width: 599px) {\n    left: 6px;\n    top: 6px;\n  }\n"]);

  _templateObject68 = function _templateObject68() {
    return data;
  };

  return data;
}

function _templateObject67() {
  var data = _taggedTemplateLiteral(["\n  right: -3px;\n  top: calc(\n    50% - ", "px\n  );\n"]);

  _templateObject67 = function _templateObject67() {
    return data;
  };

  return data;
}

function _templateObject66() {
  var data = _taggedTemplateLiteral(["\n  left: -3px;\n  top: calc(\n    50% - ", "px\n  );\n"]);

  _templateObject66 = function _templateObject66() {
    return data;
  };

  return data;
}

function _templateObject65() {
  var data = _taggedTemplateLiteral(["\n  cursor: ew-resize;\n  @media all and (min-width: 0) and (max-width: 599px) {\n    display: none;\n  }\n"]);

  _templateObject65 = function _templateObject65() {
    return data;
  };

  return data;
}

function _templateObject64() {
  var data = _taggedTemplateLiteral(["\n  margin-left: -11px;\n  margin-top: 0px;\n  cursor: url(", ") 9 9, ew-resize;\n  &:before {\n    top: unset;\n    bottom: 0px;\n    left: calc(\n      50% - ", "px\n    );\n  }\n"]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: -24px;\n  top: calc(50% - 12px);\n  cursor: ew-resize;\n"]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -24px;\n  top: calc(50% - 12px);\n  cursor: ew-resize;\n"]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = _taggedTemplateLiteral(["\n  margin-top: -", "px;\n  margin-left: -", "px;\n"]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border-width: 2px;\n  border-style: solid;\n  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 1);\n"]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = _taggedTemplateLiteral(["\n  cursor: none;\n"]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteral(["\n  > :last-child {\n    margin-left: 10px;\n  }\n  > :first-child {\n    margin-left: 0;\n  }\n"]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  padding: 3px 1px 2px;\n  color: ", ";\n  display: flex;\n  align-self: center;\n"]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  transition: all 0.4s cubic-bezier(0.17, 0.04, 0.03, 0.94);\n  height: 100%;\n  width: 100%;\n  z-index: ", ";\n  background-color: ", ";\n"]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n"]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["\n  z-index: ", ";\n  ", ";\n"]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background: ", ";\n  z-index: ", ";\n  ", "\n"]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  box-shadow: inset 0 0 0 2px ", ";\n  cursor: move;\n  ", "\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background: ", ";\n  z-index: ", ";\n  ", "\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n      transition: all 0.4s ease-in-out;\n    "]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n      transition: unset;\n    "]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  top: 0;\n  left: 0;\n  &:focus {\n    outline: 0;\n  }\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "px;\n  width: 4px;\n  z-index: ", ";\n  background: ", ";\n  cursor: pointer;\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n  left: -", "px;\n  top: -", "px;\n  transform-origin: center center;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2),\n    inset 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  cursor: move;\n  will-change: transform;\n  position: absolute;\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: -", "px;\n  height: ", "px;\n  width: 2px;\n  background-color: ", ";\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  color: ", ";\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  margin-left: -10px;\n  margin-top: -10px;\n  z-index: ", ";\n  will-change: transform;\n  cursor: ew-resize;\n  &:before {\n    display: block;\n    position: absolute;\n    content: '';\n    background: ", ";\n    border-radius: 50%;\n    width: ", "px;\n    height: ", "px;\n    top: ", "px;\n    left: ", "px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);\n  }\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n              margin-right: ", "px;\n            "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n              margin-left: ", "px;\n            "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n              margin-bottom: ", "px;\n            "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n              margin-top: ", "px;\n            "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n            right: ", "px;\n          "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n            left: ", "px;\n          "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n            bottom: ", "px;\n          "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n            top: ", "px;\n          "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n    &:before {\n      display: block;\n      position: absolute;\n      content: '';\n      width: ", "px;\n      height: ", "px;\n      z-index: ", ";\n      border-color: ", ";\n      border-style: solid;\n      border-width: ", ";\n      pointer-events: auto;\n      ", "\n      ", "\n      @media all and (min-width: 0) and (max-width: 599px) {\n        ", "\n        ", "\n      }\n    }\n    cursor: ", ";\n    pointer-events: none;\n  "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n              margin-right: -", "px;\n            "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n              margin-left: -", "px;\n            "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n              margin-bottom: -", "px;\n            "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n              margin-top: -", "px;\n            "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n            margin-right: -", "px;\n          "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n            margin-left: -", "px;\n          "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n            margin-bottom: -", "px;\n          "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n            margin-top: -", "px;\n          "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n            right: 0px;\n          "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n            left: 0px;\n          "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n            bottom: 0px;\n          "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n            top: 0px;\n          "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    ", "\n    ", "\n  ", "\n  ", "\n  @media all and (min-width: 0) and (max-width: 599px) {\n      width: ", "px;\n      height: ", "px;\n      ", "\n      ", "\n    }\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: inherit;\n  width: inherit;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  border: 2px solid ", ";\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2),\n    inset 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  cursor: move;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  border-style: solid;\n  border-width: 2px 0 2px 0;\n  border-color: ", ";\n  box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.2),\n    inset 0 6px 6px -6px rgba(0, 0, 0, 0.2);\n  cursor: move;\n  position: absolute;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* added this for safari, else the webcam overlay did not know the height */\n  height: 100%;\n  width: 100%;\n  margin-top: ", "px;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n            justify-content: space-between;\n          "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            justify-content: space-around;\n            bottom: 0;\n            transform: rotate(180deg);\n          "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    display: ", ";\n    flex-direction: row;\n    align-items: center;\n    height: ", "px;\n    color: ", ";\n    border-bottom: 1px solid\n      ", ";\n    padding: 8px 24px;\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    z-index: ", ";\n    background: ", ";\n    ", "\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          opacity: 0;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          opacity: 1;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  position: absolute;\n  transform: translate(-50%, -100%);\n  background: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  white-space: nowrap;\n  transition: opacity 0.3s ease-in-out;\n  z-index: ", ";\n\n  ", " {\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0px;\n      top: 6px;\n      height: calc(100% - 12px);\n      border-right: 1px solid\n        ", ";\n      &:last-child {\n        border-right: unset;\n      }\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  padding: 4px 10px;\n  position: relative;\n  /* for safari */\n  margin: 0;\n  &:last-child:after {\n    opacity: 0;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 56px;\n  width: 56px;\n  border-radius: 50%;\n  background-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 60px;\n  height: 60px;\n  background-color: gray;\n  border-radius: 50%;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ", ";\n  padding: 2px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { $ as Ei, B as mi, I as Bt, K as bl, M as kl, N as ae, O as qo, Q as xl, R as yl, S as Cl, T as ha, U as Sl, V as Dl, X as Tl, Y as di, Z as _a, aa as Qa, b as ai, ba as ee, ca as $t, d as pi, da as b, e as Bo, fa as k, h as Ys, ha as d, ia as Qs, ka as g, l as zl, m as Ll, ma as dn, q as Za, v as Pi, w as Ii, x as Po } from "./chunk.XE4R76IY.js";
import { B as wo, I as x, b as D, d as I, i as $, k as ne, n as P, z as f } from "./chunk.WNPNZHNS.js";

var De = function De() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ai();
  return !!t.match(/windows/i);
},
    Te = function Te() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ai();
  return t.indexOf("Safari") !== -1 && t.indexOf("Chrome") === -1;
};

var li = function li(t) {
  return t.key === "Enter";
};

var Be = function Be(t) {
  return function (o) {
    li(o) && t(o);
  };
};

var ul = function ul(t) {
  return t * .08;
},
    gl = function gl(t) {
  return t * .03;
};

var Jt = function Jt(n) {
  var t = n.label,
      o = n.icon,
      e = n.children,
      r = Cl(n, ["label", "icon", "children"]);
  return pi.createElement(bl, x({}, r), pi.createElement(xl, null, o));
};

var Bl = function Bl(_ref) {
  var t = _ref.children,
      o = _ref.className,
      e = _ref.caret,
      r = _ref.isActive,
      n = _ref.style,
      i = _ref.withBackground,
      l = _ref.hidden;
  if (l) return Bo.createElement(Tl, null, t);

  var s = function s() {
    return Bo.createElement(Dl, null, Bo.createElement(Sl, {
      "aria-hidden": !0,
      rotation: r ? 180 : 0,
      withBackground: i
    }));
  };

  return Bo.createElement(yl, {
    className: o,
    withBackground: i,
    style: n
  }, Bo.createElement(kl, {
    "data-test": b.CardLabel
  }, t, e && s()));
};

var Al = {
  Focused: zl,
  VisuallyHidden: Ll
};
import ci from "styled-components";
var Me = ci(qo)(_templateObject(), function (t) {
  return t.theme.measurements.fontSystem.button2.size;
}, function (t) {
  return t.theme.measurements.fontSystem.button2.letterSpacing;
}, function (t) {
  return t.theme.measurements.fontSystem.button2.case;
}, function (t) {
  return t.theme.button.textSecondaryForeground;
}, mi, function (t) {
  return t.theme.button.textInactiveOpacity;
});
import ze from "react";
import Le from "styled-components";

var hi = Le(di)(_templateObject2(), function (t) {
  return t.theme.measurements.zIndex.button.float;
}),
    fi = Le.div(_templateObject3(), function (t) {
  return t.theme.webcam.floatButton;
}),
    Ae = function Ae(t) {
  return ze.createElement(hi, x({}, t), ze.createElement(fi, null));
};

import Qo, { css as Pe } from "styled-components";

var Ie = Qo.div(_templateObject4()),
    Mo = Qo(qo)(_templateObject5(), function (t) {
  return t.theme.canvasActionBar.background;
}, function (t) {
  return t.theme.canvasActionBar.foreground;
}, function (t) {
  return t.theme.measurements.fontSystem.button2.size;
}, function (t) {
  return t.theme.measurements.fontSystem.button2.letterSpacing;
}, function (t) {
  return t.theme.measurements.fontSystem.button2.case;
}),
    _o = Qo.div(_templateObject6(), function (_ref2) {
  var t = _ref2.show;
  return t ? Pe(_templateObject7()) : Pe(_templateObject8());
}, function (t) {
  return t.theme.canvasActionBar.background;
}, function (t) {
  return t.theme.canvasActionBar.foreground;
}, function (t) {
  return t.theme.canvasActionBar.borderRadius ? t.theme.canvasActionBar.borderRadius : t.theme.shape.radiusMedium;
}, function (t) {
  return t.theme.measurements.zIndex.buttonGroup;
}, Mo, function (t) {
  return t.theme.canvasActionBar.separatorColor;
});

import ui from "styled-components";
var Ro = ui.div(_templateObject9());
import gi, { css as Ee } from "styled-components";
var He = gi.div.attrs(function () {
  return {
    "data-test": b.MainCanvasActionBar
  };
})(_templateObject10(), function (t) {
  return t.hide ? "none" : "flex";
}, function (t) {
  return t.theme.measurements.mainCanvasActionBar.height;
}, function (t) {
  return t.theme.mainCanvasActionBar.foreground;
}, function (t) {
  return t.theme.mainCanvasActionBar.borderColor;
}, function (t) {
  return t.theme.measurements.zIndex.canvas.bar;
}, function (t) {
  return t.transparentBackgound ? "transparent" : t.theme.mainCanvasActionBar.background;
}, function (t) {
  return t.bottom ? Ee(_templateObject11()) : Ee(_templateObject12());
});
import vi from "styled-components";
var Oe = vi.canvas(_templateObject13());
import bi from "styled-components";
var Fe = bi.div.attrs({
  role: "main"
})(_templateObject14(), function (t) {
  return t.theme.canvas.background;
}, function (t) {
  return t.theme.measurements.canvas.marginTop;
});
import xi from "styled-components";
var We = xi.div.attrs(function (_ref3) {
  var t = _ref3.height,
      o = _ref3.width;
  return {
    style: {
      height: "".concat(t, "px"),
      width: "".concat(o, "px")
    }
  };
})(_templateObject15(), function (t) {
  return t.theme.canvas.controlsOutline;
});
import Ci from "styled-components";
var Ve = Ci.div.attrs(function (_ref4) {
  var t = _ref4.radius;
  return {
    style: {
      height: "".concat(t * 2, "px"),
      width: "".concat(t * 2, "px")
    }
  };
})(_templateObject16(), function (t) {
  return t.theme.canvas.controlsOutline;
});
import wi from "styled-components";
var Ne = wi.div(_templateObject17());
import Ue, { css as z } from "styled-components";
var ki = Ue.div(function (t) {
  var _t$theme$measurements = t.theme.measurements.canvasControls.corner.touchable,
      o = _t$theme$measurements.desktop,
      e = _t$theme$measurements.mobile,
      r = o / 4,
      n = e / 2;
  return z(_templateObject18(), o, o, function (i) {
    return i.vertical === "top" ? z(_templateObject19()) : z(_templateObject20());
  }, function (i) {
    return i.horizontal === "left" ? z(_templateObject21()) : z(_templateObject22());
  }, function (i) {
    return i.vertical === "top" ? z(_templateObject23(), r) : z(_templateObject24(), r);
  }, function (i) {
    return i.horizontal === "left" ? z(_templateObject25(), r) : z(_templateObject26(), r);
  }, e, e, function (i) {
    return i.vertical === "top" ? z(_templateObject27(), n) : z(_templateObject28(), n);
  }, function (i) {
    return i.horizontal === "left" ? z(_templateObject29(), n) : z(_templateObject30(), n);
  });
}),
    zo = Ue(ki)(function (t) {
  var o = t.horizontal === "right" ? t.borderWidth : 0,
      e = t.vertical === "bottom" ? t.borderWidth : 0,
      r = t.horizontal === "left" ? t.borderWidth : 0,
      i = "".concat(t.vertical === "top" ? t.borderWidth : 0, "px ").concat(o, "px ").concat(e, "px ").concat(r, "px"),
      l = t.horizontal === "left" && t.vertical === "bottom" || t.horizontal === "right" && t.vertical === "top" ? "nesw-resize" : "nwse-resize",
      s = t.theme.measurements.canvasControls.corner.touchable.desktop / 4 - t.borderWidth,
      p = t.theme.measurements.canvasControls.corner.touchable.mobile / 4 + t.borderWidth;
  return z(_templateObject31(), function (a) {
    return a.theme.measurements.canvasControls.corner.size;
  }, function (a) {
    return a.theme.measurements.canvasControls.corner.size;
  }, function (a) {
    return a.theme.measurements.zIndex.canvas.controls;
  }, function (a) {
    return a.theme.canvas.controlsColor;
  }, i, t.vertical === "top" ? z(_templateObject32(), s) : z(_templateObject33(), s), t.horizontal === "left" ? z(_templateObject34(), s) : z(_templateObject35(), s), t.vertical === "top" ? z(_templateObject36(), p) : z(_templateObject37(), p), t.horizontal === "left" ? z(_templateObject38(), p) : z(_templateObject39(), p), l);
});
import yi from "styled-components";
var Ke = yi.div.attrs(function () {
  return {
    "data-test": b.Knob
  };
})(_templateObject40(), function (t) {
  return t.theme.measurements.canvasControls.knob.touchable.desktop;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.touchable.desktop;
}, function (t) {
  return t.theme.measurements.zIndex.canvas.knob;
}, function (t) {
  return t.theme.canvas.controlsColor;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.size;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.size;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.size / 4;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.size / 4;
});
import Si from "styled-components";
var Xe = Si.div(_templateObject41(), function (t) {
  return t.theme.canvas.controlsOutline;
});
import Di from "styled-components";
var $e = Di.div.attrs(function (t) {
  return {
    style: {
      left: "".concat(t.x, "px")
    }
  };
})(_templateObject42(), function (t) {
  return t.theme.measurements.canvasControls.sprite.rotateHandle.height;
}, function (t) {
  return t.theme.measurements.canvasControls.sprite.rotateHandle.height;
}, function (t) {
  return t.theme.canvas.controlsOutline;
});
import Ti from "styled-components";
var Ge = Ti.div.attrs(function (_ref5) {
  var t = _ref5.height,
      o = _ref5.width,
      e = _ref5.theme;
  return {
    style: {
      height: "".concat(t + e.measurements.canvasControls.sprite.controlPadding, "px"),
      width: "".concat(o + e.measurements.canvasControls.sprite.controlPadding, "px")
    }
  };
})(_templateObject43(), function (t) {
  return t.theme.measurements.canvasControls.sprite.controlPadding / 2;
}, function (t) {
  return t.theme.measurements.canvasControls.sprite.controlPadding / 2;
}, function (t) {
  return t.theme.canvas.controlsColor;
});
import Bi from "styled-components";
var je = Bi.div.attrs(function () {
  return {
    "data-test": b.TextWidth
  };
})(_templateObject44(), function (t) {
  return t.theme.measurements.canvasControls.width.size;
}, function (t) {
  return t.theme.measurements.zIndex.canvas.controls;
}, function (t) {
  return t.theme.canvas.controlsColor;
});
import Mi from "styled-components";
var Ze = Mi.div.attrs({
  tabIndex: 0
})(_templateObject45(), function (t) {
  return t.height;
}, function (t) {
  return t.width;
});
import Lo, { css as Ye } from "styled-components";
var Ao = Te() ? Ye(_templateObject46()) : Ye(_templateObject47()),
    Je = Lo.div(_templateObject48(), function (t) {
  return t.theme.canvas.cropBackdrop;
}, function (t) {
  return t.theme.measurements.zIndex.canvas.crop.backdrop;
}, Ao),
    qe = Lo.div.attrs({
  "data-test": b.CropMask
})(_templateObject49(), function (t) {
  return t.theme.canvas.controlsOutline;
}, Ao),
    Qe = Lo.div(_templateObject50(), function (t) {
  return t.theme.canvas.controlsOutline;
}, function (t) {
  return t.theme.measurements.zIndex.canvas.crop.grid;
}, Ao),
    Pt = Lo(zo)(_templateObject51(), function (t) {
  return t.theme.measurements.zIndex.canvas.controls;
}, Ao);
import zi from "styled-components";

var _e = zi.canvas(_templateObject52());

import Li from "styled-components";
var Re = Li.video(_templateObject53());
import Ai from "styled-components";
var tr = Ai.div(_templateObject54(), function (t) {
  return t.theme.measurements.zIndex.canvas.webcam.backdrop;
}, function (t) {
  return t.theme.webcam.background;
});
var c = {
  Index: Oe,
  Area: Ro,
  Bar: {
    Index: He,
    ButtonGroup: Ie
  },
  Button: {
    TextSecondary: Me,
    Float: Ae
  },
  Container: Fe,
  Element: _e,
  Wrapper: tr,
  Webcam: Re,
  Controls: {
    Knob: Ke,
    Circle: Ve,
    Corner: zo,
    Line: Xe,
    Area: We,
    Sprite: Ge,
    RotateHandle: $e,
    Container: Ne,
    Wrapper: Ze,
    SpriteActionsWrapper: _o,
    SpriteActionButton: Mo,
    Width: je
  },
  Crop: {
    Mask: qe,
    GridLine: Qe,
    Backdrop: Je,
    Control: Pt
  }
};

var or = function or() {
  var _this = this;

  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, or);

  this.getAdvancedCategoryCard = function () {
    return _this.components.advancedUICategoryCard;
  };

  this.getAdvancedItemCard = function () {
    return _this.components.advancedUIItemCard;
  };

  this.getAdvancedToolbarItem = function () {
    return _this.components.advancedUIToolbarItem;
  };

  this.getDialog = function () {
    return _this.components.dialog;
  };

  this.getButton = function (o) {
    return _this.components.buttons[o];
  };

  this.getColorItem = function () {
    return _this.components.colorItem;
  };

  this.getCheckbox = function () {
    return _this.components.checkbox;
  };

  var r = {
    dialog: k.Dialog,
    colorItem: k.ColorItem,
    checkbox: k.Input.Checkbox,
    buttons: {
      mainCanvasActionUndo: c.Button.TextSecondary,
      mainCanvasActionRedo: c.Button.TextSecondary,
      mainCanvasActionExport: Pi,
      mainCanvasActionClose: Po,
      canvasActionEdit: c.Controls.SpriteActionButton,
      canvasActionBringToFront: c.Controls.SpriteActionButton,
      canvasActionDuplicate: c.Controls.SpriteActionButton,
      canvasActionDelete: c.Controls.SpriteActionButton,
      canvasActionInvert: c.Controls.SpriteActionButton,
      canvasActionFlip: c.Controls.SpriteActionButton,
      transformActionFlipHorizontal: Jt,
      transformActionFlipVertical: Jt,
      transformActionRotateClockwise: Jt,
      transformActionRotateAntiClockwise: Jt,
      textAlignment: Jt,
      toolControlBarPrimaryButton: Ii,
      toolControlBarSecondaryButton: Po
    }
  };
  this.components = Ei([r, e, o]);
};

import G from "react";
import Xs from "styled-components";
import lt from "react";

var Hi = function Hi() {
  return lt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, lt.createElement("defs", null, lt.createElement("path", {
    id: "photoeditorsdk-blacks-icon",
    d: "M24 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12m0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10m4 12c0 2.788-2.326 3.879-7 3V18.5c4.148-.459 6.516.226 6.516 2.623 0 1.207-.492 1.998-1.512 2.474C27.504 23.999 28 24.619 28 26zm-5-6v3c2.244.068 2.775-.719 2.775-1.536 0-1.22-.531-1.812-2.775-1.464zm0 7.5c2.19.193 3.038-.04 3.038-1.484 0-1.37-1.096-1.695-3.038-1.516v3z"
  })), lt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, lt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), lt.createElement("mask", {
    fill: "currentColor"
  }, lt.createElement("use", {
    xlinkHref: "#photoeditorsdk-blacks-icon"
  })), lt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-blacks-icon"
  })));
},
    er = Hi;

import It from "react";

var Oi = function Oi() {
  return It.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, It.createElement("defs", null, It.createElement("path", {
    id: "photoeditorsdk-brightness-icon",
    d: "M22.185 33.836c.594.109 1.2.164 1.815.164v2c-.735 0-1.462-.066-2.175-.197zm5.58-.568l.753 1.852c-.675.275-1.375.487-2.093.635l-.402-1.96c.597-.122 1.18-.299 1.741-.527zm-9.446-1.037c.5.346 1.03.646 1.586.895l-.82 1.824c-.666-.3-1.303-.66-1.903-1.074zm12.884-1.295l1.44 1.388a12.06 12.06 0 01-1.65 1.429l-1.167-1.625a10.06 10.06 0 001.377-1.192zm-15.758-1.754c.316.52.679 1.01 1.083 1.464l-1.493 1.33a12.038 12.038 0 01-1.3-1.756zm17.97-1.802l1.882.676a11.948 11.948 0 01-.925 1.982l-1.727-1.008a9.948 9.948 0 00.77-1.65zM24 18c.091 0 .182.002.273.006L24 18a6.071 6.071 0 01.668.037l.192.024a5.974 5.974 0 011.847.585l.01.005a5.992 5.992 0 011.154.768A5.99 5.99 0 0130 24c0 3.309-2.691 6-6 6a5.985 5.985 0 01-4.404-1.929l.163.17a6.052 6.052 0 01-1.353-2.07A5.951 5.951 0 0118 24c0-3.309 2.691-6 6-6zm2.827 3.173l-5.654 5.654A3.988 3.988 0 0024 28c2.206 0 4-1.794 4-4a3.988 3.988 0 00-1.173-2.827zM14.08 25.268c.076.606.208 1.2.392 1.777l-1.905.608a11.936 11.936 0 01-.472-2.134zm21.885-2.192a12.16 12.16 0 01-.032 2.198l-1.989-.21a10.193 10.193 0 00.027-1.836zM12.522 20.49l1.912.584a9.943 9.943 0 00-.37 1.783l-1.987-.226c.083-.73.232-1.445.445-2.14zm22.059-2.155c.345.643.63 1.316.853 2.013l-1.905.608a9.934 9.934 0 00-.71-1.676zm-19.587-2.266l1.5 1.323c-.402.456-.762.948-1.075 1.47l-1.715-1.03c.376-.625.808-1.215 1.29-1.763zm16.272-1.62c.58.442 1.12.936 1.61 1.476l-1.479 1.346c-.41-.45-.859-.862-1.343-1.23zm-12.241-1.372l.83 1.82a9.986 9.986 0 00-1.58.903l-1.147-1.638a11.986 11.986 0 011.897-1.085zm7.7-.766c.714.166 1.408.396 2.076.688L28 14.832a9.916 9.916 0 00-1.727-.573zm-2.857-.31l.021 2c-.613.006-1.22.068-1.812.184l-.383-1.964a12.046 12.046 0 012.174-.22z"
  })), It.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, It.createElement("mask", null, It.createElement("use", {
    xlinkHref: "#photoeditorsdk-brightness-icon"
  })), It.createElement("use", {
    fillOpacity: "0.9",
    transform: "rotate(-45 24.039 24)",
    xlinkHref: "#photoeditorsdk-brightness-icon"
  })));
},
    rr = Oi;

import pt from "react";

var Fi = function Fi() {
  return pt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, pt.createElement("defs", null, pt.createElement("path", {
    id: "photoeditorsdk-clarity-icon",
    d: "M24 12L13 24.001 24 36l11-11.999L24 12zm-8.29 12.001H21l3-9.041 8.29 9.041-8.28 9.029L28 24.001h-7l2.99 9.029-8.28-9.029z"
  })), pt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, pt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), pt.createElement("mask", {
    fill: "currentColor"
  }, pt.createElement("use", {
    xlinkHref: "#photoeditorsdk-clarity-icon"
  })), pt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-clarity-icon"
  })));
},
    nr = Fi;

import ct from "react";

var Wi = function Wi() {
  return ct.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, ct.createElement("defs", null, ct.createElement("path", {
    id: "photoeditorsdk-contrast-icon",
    d: "M24 34V14c5.51 0 10 4.49 10 10s-4.49 10-10 10m0-22c-6.62 0-12 5.38-12 12s5.38 12 12 12 12-5.38 12-12-5.38-12-12-12"
  })), ct.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, ct.createElement("path", {
    d: "M0 0H48V48H0z"
  }), ct.createElement("mask", {
    fill: "currentColor"
  }, ct.createElement("use", {
    xlinkHref: "#photoeditorsdk-contrast-icon"
  })), ct.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-contrast-icon"
  })));
},
    ir = Wi;

import mt from "react";

var Vi = function Vi() {
  return mt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, mt.createElement("defs", null, mt.createElement("path", {
    id: "photoeditorsdk-exposure-icon",
    d: "M24 34V14c5.51 0 10 4.49 10 10s-4.49 10-10 10m0-22c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12 5.38-12 12-12zm-3.536 8.464l-2.121 2.122-2.121-2.122-1.414 1.415L16.929 24l-2.121 2.121 1.414 1.415 2.121-2.122 2.121 2.122 1.415-1.415L19.757 24l2.122-2.121-1.415-1.415zm5.304 4.597l4.242-4.243 1.415 1.414-4.243 4.243-1.414-1.414z"
  })), mt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, mt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), mt.createElement("mask", {
    fill: "currentColor"
  }, mt.createElement("use", {
    xlinkHref: "#photoeditorsdk-exposure-icon"
  })), mt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    transform: "rotate(45 24 24)",
    xlinkHref: "#photoeditorsdk-exposure-icon"
  })));
},
    sr = Vi;

import dt from "react";

var Ni = function Ni() {
  return dt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, dt.createElement("defs", null, dt.createElement("path", {
    id: "photoeditorsdk-gamma-icon",
    d: "M22.185 33.836c.594.109 1.2.164 1.815.164v2c-.735 0-1.462-.066-2.175-.197zm5.58-.568l.753 1.852c-.675.275-1.375.487-2.093.635l-.402-1.96c.597-.122 1.18-.299 1.741-.527zm-9.446-1.037c.5.346 1.03.646 1.586.895l-.82 1.824c-.666-.3-1.303-.66-1.903-1.074zm12.884-1.295l1.44 1.388a12.06 12.06 0 01-1.65 1.429l-1.167-1.625a10.06 10.06 0 001.377-1.192zm-15.758-1.754c.316.52.679 1.01 1.083 1.464l-1.493 1.33a12.038 12.038 0 01-1.3-1.756zm17.97-1.802l1.882.676a11.948 11.948 0 01-.925 1.982l-1.727-1.008a9.948 9.948 0 00.77-1.65zM24 18c.091 0 .182.002.273.006L24 18a6.071 6.071 0 01.668.037l.192.024a5.974 5.974 0 011.847.585l.01.005a5.992 5.992 0 011.154.768A5.99 5.99 0 0130 24c0 3.309-2.691 6-6 6a5.985 5.985 0 01-4.404-1.929l.163.17a6.052 6.052 0 01-1.353-2.07A5.951 5.951 0 0118 24c0-3.309 2.691-6 6-6zm2.827 3.173l-5.654 5.654A3.988 3.988 0 0024 28c2.206 0 4-1.794 4-4a3.988 3.988 0 00-1.173-2.827zM14.08 25.268c.076.606.208 1.2.392 1.777l-1.905.608a11.936 11.936 0 01-.472-2.134zm21.885-2.192a12.16 12.16 0 01-.032 2.198l-1.989-.21a10.193 10.193 0 00.027-1.836zM12.522 20.49l1.912.584a9.943 9.943 0 00-.37 1.783l-1.987-.226c.083-.73.232-1.445.445-2.14zm22.059-2.155c.345.643.63 1.316.853 2.013l-1.905.608a9.934 9.934 0 00-.71-1.676zm-19.587-2.266l1.5 1.323c-.402.456-.762.948-1.075 1.47l-1.715-1.03c.376-.625.808-1.215 1.29-1.763zm16.272-1.62c.58.442 1.12.936 1.61 1.476l-1.479 1.346c-.41-.45-.859-.862-1.343-1.23zm-12.241-1.372l.83 1.82a9.986 9.986 0 00-1.58.903l-1.147-1.638a11.986 11.986 0 011.897-1.085zm7.7-.766c.714.166 1.408.396 2.076.688L28 14.832a9.916 9.916 0 00-1.727-.573zm-2.857-.31l.021 2c-.613.006-1.22.068-1.812.184l-.383-1.964a12.046 12.046 0 012.174-.22z"
  })), dt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, dt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), dt.createElement("mask", {
    fill: "#fff"
  }, dt.createElement("use", {
    xlinkHref: "#photoeditorsdk-gamma-icon"
  })), dt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-gamma-icon"
  })));
},
    ar = Ni;

import ht from "react";

var Ui = function Ui() {
  return ht.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, ht.createElement("defs", null, ht.createElement("path", {
    id: "photoeditorsdk-highlights-icon",
    d: "M31.07 31.07A9.932 9.932 0 0124 34c-2.67 0-5.18-1.04-7.07-2.93l14.14-14.14c3.9 3.9 3.9 10.24 0 14.14m1.42-15.56A11.995 11.995 0 0024 12c-3.07 0-6.14 1.17-8.49 3.51-4.68 4.69-4.68 12.29 0 16.98C17.86 34.83 20.93 36 24 36c3.07 0 6.14-1.17 8.49-3.51 4.68-4.69 4.68-12.29 0-16.98"
  })), ht.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, ht.createElement("path", {
    d: "M0 0H48V48H0z"
  }), ht.createElement("mask", {
    fill: "currentColor"
  }, ht.createElement("use", {
    xlinkHref: "#photoeditorsdk-highlights-icon"
  })), ht.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-highlights-icon"
  })));
},
    lr = Ui;

import ft from "react";

var Ki = function Ki() {
  return ft.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, ft.createElement("defs", null, ft.createElement("path", {
    id: "photoeditorsdk-saturation-icon",
    d: "M17 31c1.334 1.099 2 2.177 2 3.234 0 .797-.454 1.39-1.211 1.655-.165.057-.428.094-.789.111l-.172-.01a2.54 2.54 0 01-.617-.101C15.454 35.624 15 35.03 15 34.234c0-1.057.666-2.135 2-3.234zm8.7-6l-4.24 4H17v-3.81l.2-.19h8.5zm-.7-7.59l4.24 4.25L26.76 24h-8.54L25 17.41zm7.778-3.532a3 3 0 01.135 4.1l-.135.143-1.414 1.414 1.414 1.415-1.414 1.414-7.07-7.071 1.413-1.414 1.414 1.413 1.414-1.414a3.001 3.001 0 014.243 0z"
  })), ft.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, ft.createElement("path", {
    d: "M0 0H48V48H0z"
  }), ft.createElement("mask", {
    fill: "currentColor"
  }, ft.createElement("use", {
    xlinkHref: "#photoeditorsdk-saturation-icon"
  })), ft.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-saturation-icon"
  })));
},
    pr = Ki;

import ut from "react";

var Xi = function Xi() {
  return ut.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, ut.createElement("defs", null, ut.createElement("path", {
    id: "photoeditorsdk-shadows-icon",
    d: "M30.365 17.637l3.076 3.076c.382 1.09.566 2.234.56 3.387l-5.05-5.049-1.414 1.414 6.123 6.124a9.674 9.674 0 01-.792 2.036l-6.746-6.745-1.414 1.414 7.036 7.036c-.212.254-.43.502-.672.742-.24.24-.488.46-.742.672l-7.036-7.036-1.414 1.414 6.745 6.746a9.674 9.674 0 01-2.036.792l-6.124-6.123-1.414 1.414L24.101 34a10.012 10.012 0 01-3.388-.558l-3.076-3.076-.707.707c-3.896-3.896-3.896-10.246 0-14.142 3.896-3.896 10.246-3.896 14.142 0l-.707.707zm-14.849-2.12c-4.688 4.687-4.688 12.281 0 16.97a12.036 12.036 0 004.108 2.693c.064.022.127.057.191.078 4.264 1.577 9.242.658 12.671-2.772 3.43-3.429 4.35-8.407 2.772-12.67-.02-.065-.056-.128-.078-.192a12.036 12.036 0 00-2.694-4.108c-4.688-4.688-12.282-4.688-16.97 0z"
  })), ut.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, ut.createElement("path", {
    d: "M0 0H48V48H0z"
  }), ut.createElement("mask", {
    fill: "currentColor"
  }, ut.createElement("use", {
    xlinkHref: "#photoeditorsdk-shadows-icon"
  })), ut.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-shadows-icon"
  })));
},
    cr = Xi;

import gt from "react";

var $i = function $i() {
  return gt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, gt.createElement("defs", null, gt.createElement("path", {
    id: "photoeditorsdk-sharpness-icon",
    d: "M24 12l11 24H13l11-24zm0 4.8V34h7.883L24 16.8z"
  })), gt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, gt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), gt.createElement("mask", {
    fill: "currentColor"
  }, gt.createElement("use", {
    xlinkHref: "#photoeditorsdk-sharpness-icon"
  })), gt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-sharpness-icon"
  })));
},
    mr = $i;

import vt from "react";

var Gi = function Gi() {
  return vt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, vt.createElement("defs", null, vt.createElement("path", {
    id: "photoeditorsdk-temperature-icon",
    d: "M24 12a4 4 0 014 4v7.255a7 7 0 11-8 0V16a4 4 0 014-4zm0 2a2 2 0 00-2 2v8.298l-.856.597a5 5 0 105.712 0L26 24.298V16a2 2 0 00-2-2zm1 6v5.126A4.002 4.002 0 0124 33a4 4 0 01-1-7.874V20h2z"
  })), vt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, vt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), vt.createElement("mask", {
    fill: "currentColor"
  }, vt.createElement("use", {
    xlinkHref: "#photoeditorsdk-temperature-icon"
  })), vt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-temperature-icon"
  })));
},
    dr = Gi;

import bt from "react";

var ji = function ji() {
  return bt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, bt.createElement("defs", null, bt.createElement("path", {
    id: "photoeditorsdk-whites-icon",
    d: "M24 12c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm-2 6.46h-2c.221 4.539.762 9.051 1 11.04h1.5l1.5-5.52 1.5 5.52H27c.238-1.989.779-6.501 1-11.04h-2c-.051 1.071-.432 7.446-.5 7.973-.459-1.717-.541-3.111-1-4.811h-1c-.442 1.7-.541 2.975-1 4.811-.051-.527-.466-6.902-.5-7.973z"
  })), bt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, bt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), bt.createElement("mask", {
    fill: "currentColor"
  }, bt.createElement("use", {
    xlinkHref: "#photoeditorsdk-whites-icon"
  })), bt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-whites-icon"
  })));
},
    hr = ji;

import Et from "react";

var Zi = function Zi() {
  return Et.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, Et.createElement("defs", null, Et.createElement("path", {
    id: "photoeditorsdk-close-icon",
    d: "M21.583 0L24 2.416 14.416 12 24 21.584 21.583 24 12 14.416 2.417 24 0 21.584 9.584 12 0 2.416 2.417 0 12 9.584 21.583 0z"
  })), Et.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Et.createElement("mask", {
    fill: "currentColor"
  }, Et.createElement("use", {
    xlinkHref: "#photoeditorsdk-close-icon"
  })), Et.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#photoeditorsdk-close-icon"
  })));
},
    fr = Zi;

import Ht from "react";

function Yi() {
  return Ht.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, Ht.createElement("defs", null, Ht.createElement("path", {
    id: "photoeditorsdk-export-icon",
    d: "M22 1.5a1.5 1.5 0 011.493 1.356L23.5 3H22h1.5v17a1.5 1.5 0 01-1.5 1.5H12a1.5 1.5 0 01-1.493-1.356L10.5 20v-6h2v5.499h9v-16h-9V9h-2V3A1.5 1.5 0 0112 1.5h10zM6.15 5.817L7.634 7.3l-3.171 3.171h13.978v2H4.47l3.171 3.17-1.483 1.483L.5 11.467l5.65-5.65z"
  })), Ht.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Ht.createElement("mask", {
    fill: "#fff"
  }, Ht.createElement("use", {
    xlinkHref: "#photoeditorsdk-export-icon"
  })), Ht.createElement("use", {
    fill: "currentcolor",
    fillOpacity: "0.9",
    transform: "rotate(90 12 11.5)",
    xlinkHref: "#photoeditorsdk-export-icon"
  })));
}

var ur = Yi;
import Ot from "react";

var Ji = function Ji() {
  return Ot.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, Ot.createElement("defs", null, Ot.createElement("path", {
    id: "photoeditorsdk-redo-icon",
    d: "M4 10.065C4 4.506 8.365 0 13.75 0s9.75 4.506 9.75 10.065v9.29h-3v-9.29c0-3.849-3.022-6.968-6.75-6.968S7 6.217 7 10.065v7.741h3L5.5 24 1 17.806h3v-7.741z"
  })), Ot.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Ot.createElement("mask", {
    fill: "currentColor"
  }, Ot.createElement("use", {
    xlinkHref: "#photoeditorsdk-redo-icon"
  })), Ot.createElement("use", {
    fill: "currentColor",
    transform: "matrix(0 1 1 0 .25 -.25)",
    xlinkHref: "#photoeditorsdk-redo-icon"
  })));
},
    gr = Ji;

import Ft from "react";

var qi = function qi() {
  return Ft.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, Ft.createElement("defs", null, Ft.createElement("path", {
    id: "photoeditorsdk-undo-icon",
    d: "M4 10.065C4 4.506 8.365 0 13.75 0s9.75 4.506 9.75 10.065v9.29h-3v-9.29c0-3.849-3.022-6.968-6.75-6.968S7 6.217 7 10.065v7.741h3L5.5 24 1 17.806h3v-7.741z"
  })), Ft.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Ft.createElement("mask", {
    fill: "currentColor"
  }, Ft.createElement("use", {
    xlinkHref: "#photoeditorsdk-undo-icon"
  })), Ft.createElement("use", {
    fill: "currentColor",
    transform: "rotate(90 12.25 12)",
    xlinkHref: "#photoeditorsdk-undo-icon"
  })));
},
    vr = qi;

import Wt from "react";

function Qi() {
  return Wt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Center Align",
    width: "26",
    height: "26"
  }, Wt.createElement("defs", null, Wt.createElement("path", {
    id: "photoeditorsdk-align-center-icon",
    d: "M31.5 30v3h-15v-3h15zm4.5-7.5v3H12v-3h24zm0-7.5v3H12v-3h24z"
  })), Wt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Wt.createElement("mask", {
    fill: "#fff"
  }, Wt.createElement("use", {
    xlinkHref: "#photoeditorsdk-align-center-icon"
  })), Wt.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#photoeditorsdk-align-center-icon"
  })));
}

var br = Qi;
import Vt from "react";

var _i = function _i() {
  return Vt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Left Align",
    width: "26",
    height: "26"
  }, Vt.createElement("defs", null, Vt.createElement("path", {
    id: "photoeditorsdk-align-left-icon",
    d: "M27 30v3H12v-3h15zm9-7.5v3H12v-3h24zm0-7.5v3H12v-3h24z"
  })), Vt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Vt.createElement("mask", {
    fill: "#fff"
  }, Vt.createElement("use", {
    xlinkHref: "#photoeditorsdk-align-left-icon"
  })), Vt.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#photoeditorsdk-align-left-icon"
  })));
},
    xr = _i;

import xt from "react";

function Ri() {
  return xt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "26",
    height: "26",
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Right Align"
  }, xt.createElement("defs", null, xt.createElement("path", {
    id: "photoeditorsdk-align-right-icon",
    d: "M27 30v3H12v-3h15zm9-7.5v3H12v-3h24zm0-7.5v3H12v-3h24z"
  })), xt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, xt.createElement("path", {
    d: "M0 0H48V48H0z"
  }), xt.createElement("mask", {
    fill: "#fff"
  }, xt.createElement("use", {
    xlinkHref: "#photoeditorsdk-align-right-icon"
  })), xt.createElement("use", {
    fill: "currentColor",
    transform: "matrix(-1 0 0 1 48 0)",
    xlinkHref: "#photoeditorsdk-align-right-icon"
  })));
}

var Cr = Ri;
import O from "react";

var ts = function ts() {
  return O.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Adjustments",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, O.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, O.createElement("g", null, O.createElement("g", {
    fill: "#D8D8D8",
    opacity: "0"
  }, O.createElement("rect", {
    width: "48",
    height: "48"
  })), O.createElement("g", {
    transform: "translate(12 12)"
  }, O.createElement("rect", {
    fill: "#D8D8D8",
    opacity: "0",
    width: "24",
    height: "24"
  }), O.createElement("g", {
    transform: "translate(2 13)",
    fill: "currentColor"
  }, O.createElement("path", {
    d: "M3.02746439,4 C3.00931666,4.16416693 3,4.33099545 3,4.5 C3,4.66900455 3.00931666,4.83583307 3.02746439,5 L0,5 L0,4 L3.02746439,4 Z M13,4 L20,4 L20,5 L13,5 L13,4 Z",
    fillOpacity: "0.2"
  }), O.createElement("path", {
    d: "M5.09842503,6.29819429 C5.0340931,6.05140089 5,5.7851211 5,5.5 C5,3.56700338 6.56700338,2 8.5,2 C8.7851211,2 9.05140089,2.0340931 9.29819429,2.09842503 C10.0278893,2.64566496 10.5,3.5176988 10.5,4.5 C10.5,6.15685425 9.15685425,7.5 7.5,7.5 C6.5176988,7.5 5.64566496,7.02788926 5.09842503,6.29819429 Z M11.1637159,7.11349161 C10.874061,7.51881791 10.5188179,7.87406095 10.1134916,8.16371592 C10.5772175,7.93004328 10.9300433,7.5772175 11.1637159,7.11349161 Z",
    fillOpacity: "0.2"
  }), O.createElement("path", {
    d: "M7.5,7.5 C9.15685425,7.5 10.5,6.15685425 10.5,4.5 C10.5,2.84314575 9.15685425,1.5 7.5,1.5 C5.84314575,1.5 4.5,2.84314575 4.5,4.5 C4.5,6.15685425 5.84314575,7.5 7.5,7.5 Z M7.5,9 C5.01471863,9 3,6.98528137 3,4.5 C3,2.01471863 5.01471863,0 7.5,0 C9.98528137,0 12,2.01471863 12,4.5 C12,6.98528137 9.98528137,9 7.5,9 Z",
    fillOpacity: "0.87"
  })), O.createElement("g", {
    transform: "rotate(-180 11 5.5)",
    fill: "currentColor"
  }, O.createElement("path", {
    d: "M11.9725356,4 L20,4 L20,5 L11.9725356,5 C11.9906833,4.83583307 12,4.66900455 12,4.5 C12,4.33099545 11.9906833,4.16416693 11.9725356,4 Z M0,4 L2,4 L2,5 L0,5 L0,4 Z",
    fillOpacity: "0.2"
  }), O.createElement("g", {
    transform: "rotate(-180 5 3.5)",
    fillOpacity: "0.2"
  }, O.createElement("path", {
    d: "M0.0984250251,4.29819429 C0.0340930963,4.05140089 0,3.7851211 0,3.5 C0,1.56700338 1.56700338,0 3.5,0 C3.7851211,0 4.05140089,0.0340930963 4.29819429,0.0984250251 C5.02788926,0.645664963 5.5,1.5176988 5.5,2.5 C5.5,4.15685425 4.15685425,5.5 2.5,5.5 C1.5176988,5.5 0.645664963,5.02788926 0.0984250251,4.29819429 Z M6.16371592,5.11349161 C5.87406095,5.51881791 5.51881791,5.87406095 5.11349161,6.16371592 C5.5772175,5.93004328 5.93004328,5.5772175 6.16371592,5.11349161 Z"
  })), O.createElement("path", {
    d: "M7.5,7.5 C9.15685425,7.5 10.5,6.15685425 10.5,4.5 C10.5,2.84314575 9.15685425,1.5 7.5,1.5 C5.84314575,1.5 4.5,2.84314575 4.5,4.5 C4.5,6.15685425 5.84314575,7.5 7.5,7.5 Z M7.5,9 C5.01471863,9 3,6.98528137 3,4.5 C3,2.01471863 5.01471863,-3.6739404e-16 7.5,-3.6739404e-16 C9.98528137,-3.6739404e-16 12,2.01471863 12,4.5 C12,6.98528137 9.98528137,9 7.5,9 Z",
    fillOpacity: "0.87"
  }))))));
},
    wr = ts;

import Nt from "react";

function os() {
  return Nt.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Brush",
    width: "48",
    height: "48",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, Nt.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Nt.createElement("path", {
    fillOpacity: "0.87",
    d: "M14.73 18.86C13.293 19.503 11.624 20 10 20 2 20 0 13 0 10c.486.972 2.37 5.848 7.537 4.165C7.873 17.125 10.427 19 13 19c.6 0 1.177-.05 1.73-.14zM8.422 8.63a7.352 7.352 0 00-1.127 1.616L2.401 3.705c-.215-.287-.178-.807.072-1.056l.088-.088L8.5 8.5l-.078.13z",
    opacity: "0.5",
    transform: "translate(12 12) translate(2 2)"
  }), Nt.createElement("path", {
    fillOpacity: "0.87",
    d: "M7.295 10.246c-.27.526-.48 1.09-.615 1.68L1.2 4.603c-.663-.885-.564-2.24.212-3.015l.176-.176c.78-.78 2.121-.881 3.015-.212l7.245 5.421a6.088 6.088 0 00-1.67.624L3.706 2.401c-.294-.22-.801-.184-1.056.072l-.176.176c-.25.25-.287.769-.072 1.056l4.894 6.54z",
    transform: "translate(12 12) translate(2 2)"
  }), Nt.createElement("path", {
    fillOpacity: "0.87",
    d: "M9.702 6.554c-.185-.869-.151-.71-.207-.955C8.88 2.902 8.145 2 6 2 3.98 2 2 4.08 2 6.5c0 2.294 1.835 4 4 4 1.545 0 2.915-.342 4.544-1.088-.332-.7-.578-1.619-.842-2.858z",
    opacity: "0.5",
    transform: "translate(12 12) translate(2 2) translate(7 7)"
  }), Nt.createElement("path", {
    fillOpacity: "0.25",
    d: "M10.379 9.027c.053.135.108.263.165.385C8.914 10.158 7.545 10.5 6 10.5c-2.165 0-4-1.706-4-4 0-1.528.79-2.921 1.88-3.74-.882 2.084-1.025 6.482 6.499 6.267z",
    transform: "translate(12 12) translate(2 2) translate(7 7)"
  }), Nt.createElement("path", {
    fillOpacity: "0.87",
    d: "M9.702 6.554c-.185-.869-.151-.71-.207-.955C8.88 2.902 8.145 2 6 2 3.98 2 2 4.08 2 6.5c0 2.294 1.835 4 4 4 1.545 0 2.915-.342 4.544-1.088-.332-.7-.578-1.619-.842-2.858zM6 12C3.239 12 .5 9.842.5 6.5S3.239.5 6 .5c6.5 0 4 8 7 9.342C11 10.947 8.761 12 6 12z",
    transform: "translate(12 12) translate(2 2) translate(7 7)"
  })));
}

var kr = os;
import J from "react";

var es = function es() {
  return J.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "aria-label": "Filter",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, J.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, J.createElement("g", null, J.createElement("g", {
    fill: "#D8D8D8",
    opacity: "0"
  }, J.createElement("rect", {
    width: "48",
    height: "48"
  })), J.createElement("g", {
    transform: "translate(16 14)",
    fill: "currentColor"
  }, J.createElement("g", null, J.createElement("path", {
    d: "M1.53468397,11.3244256 C2.30584171,10.1516526 4.0927284,8.69757613 8,10 C11.5643313,11.1881104 13.1877038,10.2588113 13.9183327,9.30853287 C14.2918933,10.1286474 14.5,11.0400207 14.5,12 C14.5,15.5898509 11.5898509,18.5 8,18.5 C4.41014913,18.5 1.5,15.5898509 1.5,12 C1.5,11.7718729 1.51175212,11.5464906 1.53468397,11.3244256 Z",
    fillOpacity: "0.2"
  }), J.createElement("path", {
    d: "M1.53471819,12.6759057 C2.39408133,13.5811739 4.12541941,14.1109247 5.5,13.5 C9.81068889,11.5841383 9.99203585,9.66827654 14.3948028,10.8290113 C14.4639074,11.2088572 14.5,11.6002137 14.5,12 C14.5,15.5898509 11.5898509,18.5 8,18.5 C4.63838968,18.5 1.87279864,15.9481381 1.53471819,12.6759057 Z",
    fillOpacity: "0.25"
  }), J.createElement("path", {
    d: "M11,1.44328993e-15 L11,4.58151705 C13.9318303,5.7682918 16,8.64262245 16,12 C16,16.418278 12.418278,20 8,20 C3.581722,20 0,16.418278 0,12 C0,8.64262245 2.06816966,5.7682918 5,4.58151705 L5,1.60982339e-15 L6.5,1.44328993e-15 L6.5,5.67393184 C3.6333,6.35109564 1.5,8.92641836 1.5,12 C1.5,15.5898509 4.41014913,18.5 8,18.5 C11.5898509,18.5 14.5,15.5898509 14.5,12 C14.5,8.92641836 12.3667,6.35109564 9.5,5.67393184 L9.5,1.77635684e-15 L11,1.44328993e-15 Z",
    fillOpacity: "0.87"
  }))))));
},
    yr = es;

import Y from "react";

var rs = function rs() {
  return Y.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Focus",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, Y.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, Y.createElement("g", null, Y.createElement("g", {
    fill: "#D8D8D8",
    opacity: "0"
  }, Y.createElement("rect", {
    width: "48",
    height: "48"
  })), Y.createElement("g", {
    transform: "translate(12 12)"
  }, Y.createElement("rect", {
    fill: "#D8D8D8",
    opacity: "0",
    width: "24",
    height: "24"
  }), Y.createElement("g", {
    transform: "translate(4 2)",
    fill: "currentColor"
  }, Y.createElement("path", {
    d: "M8.51312274,19.9836057 C8.77273397,19.9669655 9.02898229,19.9377873 9.2812837,19.8966625 C9.14309542,19.9643562 9.04607398,20 9,20 C8.83633495,20 8.67398178,19.9944755 8.51312274,19.9836057 Z M2.27242753,15.0235117 C2.09503729,14.4174909 2,13.7771617 2,13.115 C2,8.89625769 7.39855682,4.1952443 9.03524007,2.8669743 C9.66704719,3.45933018 10.2896864,4.09178959 10.8802638,4.75434357 C12.9939648,7.12565193 14.310818,9.45010207 14.481291,11.4644804 C14.4937541,11.6117488 14.5,11.7569175 14.5,11.9 C14.5,15.5490785 11.5855665,18.5 8,18.5 C5.525182,18.5 3.37015673,17.0943182 2.27242753,15.0235117 Z M15.999821,11.9547651 C15.9999402,11.9698392 16,11.9849176 16,12 C16,12.0581275 15.9984809,12.1163475 15.9954873,12.1746435 C15.9978914,12.1015915 15.9993401,12.0282946 15.999821,11.9547651 Z",
    fillOpacity: "0.2"
  }), Y.createElement("path", {
    d: "M3.47269084,16.6357644 C3.47244857,13.6389249 9.59189484,15.3529683 12,11.5 C13.2066771,9.56931667 12.316614,7.05620551 11.0727604,4.97270186 C13.0737756,7.26814668 14.316054,9.51197209 14.481291,11.4644804 C14.4937541,11.6117488 14.5,11.7569175 14.5,11.9 C14.5,15.5490785 11.5855665,18.5 8,18.5 C6.2411126,18.5 4.64375705,17.7899702 3.47269084,16.6357644 Z",
    fillOpacity: "0.25"
  }), Y.createElement("path", {
    d: "M7.73975027,2.16383649 C6.84545319,2.94914111 5.95084629,3.82194197 5.11973623,4.75434357 C3.00603518,7.12565193 1.68918197,9.45010207 1.51870896,11.4644804 C1.50624591,11.6117488 1.5,11.7569175 1.5,11.9 C1.5,15.5492218 4.41434886,18.5 8,18.5 C11.5855665,18.5 14.5,15.5490785 14.5,11.9 C14.5,11.7569175 14.4937541,11.6117488 14.481291,11.4644804 C14.310818,9.45010207 12.9939648,7.12565193 10.8802638,4.75434357 C10.0491537,3.82194197 9.15454681,2.94914111 8.26024973,2.16383649 C8.17157048,2.08596503 8.08476013,2.01060875 8,1.93784184 C7.91523987,2.01060875 7.82842952,2.08596503 7.73975027,2.16383649 Z M8,20 C3.581722,20 0,16.3735065 0,11.9 C0,6.05 8,0 8,0 C8,0 16,6.05 16,11.9 C16,16.3732777 12.418278,20 8,20 Z",
    fillOpacity: "0.87"
  }))))));
},
    Sr = rs;

import qt from "react";

var ns = function ns() {
  return qt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Frames",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, qt.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(12 12)"
  }, qt.createElement("path", {
    fillOpacity: "0.2",
    d: "M8 8L17 7 17 17 7 17z"
  }), qt.createElement("path", {
    fillOpacity: "0.87",
    d: "M4.5 19.5h15v-15h-15v15zM3 3h18v18H3V3z"
  }), qt.createElement("path", {
    fillOpacity: "0.87",
    d: "M7 17h10V7H7v10zM6 6h12v12H6V6z"
  }), qt.createElement("path", {
    fillOpacity: "0.25",
    d: "M9 15L11 12 13 14 14 13.5 15 15z"
  })));
},
    Dr = ns;

import K from "react";

var is = function is() {
  return K.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Library",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, K.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, K.createElement("g", {
    transform: "translate(15 15)",
    fill: "currentColor"
  }, K.createElement("g", null, K.createElement("polygon", {
    fillOpacity: "0.2",
    points: "3 3 12.5 1.5 12.5 15.5 1.5 15.5"
  }), K.createElement("path", {
    d: "M1.5,1.5 L1.5,15.5 L12.5,15.5 L12.5,1.5 L1.5,1.5 Z M0,0 L14,0 L14,17 L0,17 L0,0 Z",
    fillOpacity: "0.87"
  }), K.createElement("polygon", {
    fillOpacity: "0.25",
    points: "3 11 6 7 8 9 9 8.5 11 11"
  }), K.createElement("circle", {
    fillOpacity: "0.25",
    cx: "9",
    cy: "5",
    r: "1"
  }), K.createElement("rect", {
    fillOpacity: "0.25",
    x: "3",
    y: "13",
    width: "8",
    height: "1"
  }), K.createElement("g", {
    transform: "rotate(14 -2.352 56.952)",
    fillOpacity: "0.2"
  }, K.createElement("path", {
    d: "M1.32904158,1.07500967e-13 L5,1.07500967e-13 L5,14.7234101 L4,10.7126291 L4,1 L1.57836958,1 L1.32904158,1.07500967e-13 Z M5,14.9745817 L5,16 L0.887271787,16 L5,14.9745817 Z"
  }), K.createElement("path", {
    d: "M1.82769758,2 L3,2 L3,6.70184819 L1.82769758,2 Z"
  }))))));
},
    Tr = is;

import mo from "react";

var ss = function ss() {
  return mo.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Overlays",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, mo.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, mo.createElement("g", {
    transform: "translate(15 15)",
    fill: "currentColor"
  }, mo.createElement("path", {
    d: "M13.5,4 L13.5,13.5 L4,13.5 L4,5 C4,4.44771525 4.44771525,4 5,4 L13.5,4 Z M15,4 L17,4 C17.5522847,4 18,4.44771525 18,5 L18,17 C18,17.5522847 17.5522847,18 17,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,15 L14,15 C14.5522847,15 15,14.5522847 15,14 L15,4 Z",
    fillOpacity: "0.2"
  }), mo.createElement("path", {
    d: "M1.5,1.5 L1.5,13.5 L13.5,13.5 L13.5,1.5 L1.5,1.5 Z M1,0 L14,0 C14.5522847,-1.01453063e-16 15,0.44771525 15,1 L15,14 C15,14.5522847 14.5522847,15 14,15 L1,15 C0.44771525,15 6.76353751e-17,14.5522847 0,14 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    fillOpacity: "0.87"
  }))));
},
    Br = ss;

import tt from "react";

var as = function as() {
  return tt.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    width: "48px",
    height: "48px",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Stickers",
    viewBox: "0 0 48 48"
  }, tt.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, tt.createElement("g", null, tt.createElement("g", {
    transform: "translate(14.000000, 14.000000)",
    fill: "currentColor"
  }, tt.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    fillOpacity: "0.2"
  }, tt.createElement("path", {
    d: "M11.5840291,0.290311095 C14.1040281,1.4637822 15.9529364,3.83641178 16.3972985,6.6747443 C11.4538042,7.5567274 7.55733385,11.4556991 6.68374109,16.3973312 C3.83946575,15.9530468 1.46423317,14.1041207 0.290132399,11.5832649 C0.0988489957,10.7650202 3.01980663e-14,9.89786431 3.01980663e-14,9 C3.01980663e-14,6.64646143 0.903391324,4.50392121 2.38232909,2.90022422 C4.02683831,1.11698861 6.38297582,-3.55271368e-15 9,-3.55271368e-15 C9.89814387,-3.55271368e-15 10.7655602,0.0989105588 11.5840291,0.290311095 Z"
  }), tt.createElement("path", {
    d: "M17.9877222,8 L8,17.9877222 C8.2591955,12.5923102 12.5906864,8.26470667 17.9877222,8 Z"
  })), tt.createElement("path", {
    d: "M9.87290303,14.9211604 C9.09408801,14.4293124 5,11.7146562 5,9 C5,7.34 6.34,6 8,6 C8.77,6 9.47,6.52 10,7 C10.53,6.52 11.23,6 12,6 C13.66,6 15,7.34 15,9 C15,9.30171667 14.9494261,9.60343334 14.8584511,9.90209822 C12.7354304,11.0373368 10.9933363,12.7905402 9.87290303,14.9211604 Z",
    fillOpacity: "0.25"
  }), tt.createElement("path", {
    d: "M10,1.5 C5.30557963,1.5 1.5,5.30557963 1.5,10 C1.5,14.2449983 4.61102233,17.7611603 8.68374109,18.3973312 C9.55733385,13.4556991 13.4538042,9.5567274 18.3972985,8.6747443 C17.7608961,4.60976745 14.2436106,1.5 10,1.5 Z M0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C14.5988732,10.2649073 10.2649073,14.5988732 10.0116954,19.9999933 C4.4771525,20 0,15.5228475 0,10 Z",
    fillOpacity: "0.87"
  })))));
},
    Mr = as;

import ho from "react";

var ls = function ls() {
  return ho.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Texts",
    width: "48",
    height: "48"
  }, ho.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, ho.createElement("path", {
    fillOpacity: "0.2",
    d: "M17.883 19.5H16.07L11.702 6.833l1.235-1.411L17.883 19.5z",
    transform: "translate(12 12)"
  }), ho.createElement("path", {
    fillOpacity: "0.87",
    d: "M10.8 8.818L8.483 14.5h4.275l-1.96-5.682zM10 6.5l3.5-4 5.973 17H21V21h-8v-1.5h1.483L13.276 16H7.873l-1.426 3.5H8V21H3v-1.5h1.704L10 6.5zm1.702.333L16.069 19.5h1.814L12.937 5.422l-1.235 1.411z",
    transform: "translate(12 12)"
  }), ho.createElement("path", {
    fillOpacity: "0.2",
    d: "M19.55 15l-.35-1H21v1h-1.45zm1.05 3l-.35-1H21v1h-.4zM7.639 8L7.25 9H3V8h4.639zm1.167-3l-.39 1H7V5h1.806zm-2.334 6l-.389 1H6v-1h.472zm-1.166 3l-.39 1H3v-1h2.306zm-1.167 3l-.389 1H3v-1h1.139zM15.35 3L15 2h1v1h-.65zm3.15 9l-.35-1H21v1h-2.5zm-1.05-3l-.35-1H21v1h-3.55zM16.4 6l-.35-1H18v1h-1.6zm-5.9-3H9V2h2.5l-1 1zM3 5h3v1H3V5zm16 0h2v1h-2V5zM3 11h2v1H3v-1zm18-8h-4V2h4v1zM8 3H3V2h5v1z",
    transform: "translate(12 12)"
  })));
},
    zr = ls;

import fo from "react";

var ps = function ps() {
  return fo.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Text Design",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, fo.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, fo.createElement("path", {
    fillOpacity: "0.87",
    d: "M1 0h14a1 1 0 011 1v19l-8-6-8 6V1a1 1 0 011-1zm.5 1.5V17L8 12.125 14.5 17V1.5h-13z",
    transform: "translate(14 14) translate(2)"
  }), fo.createElement("path", {
    fillOpacity: "0.2",
    d: "M1.5 1.5h13V17L8 12.125 1.5 17V1.5z",
    transform: "translate(14 14) translate(2)"
  }), fo.createElement("path", {
    fillOpacity: "0.25",
    d: "M9 4l2.52 7H10.2l-.7-1.85H6.45L5.77 11H4.49L6.9 4H9zm-1.04.78h-.05L6.73 8.14H9.2L7.96 4.78z",
    transform: "translate(14 14) translate(2)"
  })));
},
    Lr = ps;

import Ut from "react";

function cs() {
  return Ut.createElement("svg", {
    focusable: "false",
    "aria-hidden": "true",
    "aria-label": "Transform",
    width: "48",
    height: "48",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, Ut.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(12 12)"
  }, Ut.createElement("path", {
    fillOpacity: "0.2",
    d: "M10 10L15 9 15 15 9 15z"
  }), Ut.createElement("path", {
    fillOpacity: "0.87",
    d: "M9 15h6V9H9v6zm-1.5 0V7.5H15V3h1.5v13.5H3V15h4.5zm0 2.5H9V21H7.5v-3.5zM21 7.5V9h-3.5V7.5H21z"
  }), Ut.createElement("g", {
    fillOpacity: "0.2"
  }, Ut.createElement("path", {
    d: "M0 10h1a9.003 9.003 0 015.5-8.294L7 3 10.942.044C10.632.014 10.318 0 10 0 4.477 0 0 4.477 0 10z",
    transform: "translate(2 2)"
  }), Ut.createElement("path", {
    d: "M9 20h1a9.003 9.003 0 015.5-8.294L16 13l3.942-2.956c-.31-.03-.624-.044-.942-.044-5.523 0-10 4.477-10 10z",
    transform: "translate(2 2) rotate(-180 14.47 15)"
  }))));
}

var Ar = cs;
import dc from "react";
import uc from "react";
import bc from "react";
import wc from "react";
import Sc from "react";
import Ct from "react";

var ms = function ms() {
  return Ct.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, Ct.createElement("defs", null, Ct.createElement("path", {
    id: "photoeditorsdk-bring-to-front-icon",
    d: "M21 16a2 2 0 012 2v4a2 2 0 01-2 2H3a2 2 0 01-2-2v-4a2 2 0 012-2h18zM12.006 1l5.996 5.996-1.414 1.414-3.578-3.577V12h-2.008V4.833L7.418 8.417 6.004 7.003 12.006 1z"
  })), Ct.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Ct.createElement("path", {
    d: "M0 0H24V24H0z"
  }), Ct.createElement("mask", {
    fill: "currentColor"
  }, Ct.createElement("use", {
    xlinkHref: "#photoeditorsdk-bring-to-front-icon"
  })), Ct.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-bring-to-front-icon"
  })));
},
    Pr = ms;

import E from "react";

var ds = function ds(_ref6) {
  var _ref6$highlight = _ref6.highlight,
      t = _ref6$highlight === void 0 ? "currentColor" : _ref6$highlight,
      _ref6$width = _ref6.width,
      o = _ref6$width === void 0 ? 48 : _ref6$width,
      _ref6$height = _ref6.height,
      e = _ref6$height === void 0 ? 48 : _ref6$height;
  return E.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: e,
    viewBox: "0 0 48 48"
  }, E.createElement("g", {
    fill: "none",
    fillOpacity: "0.9",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, E.createElement("g", {
    fill: t,
    transform: "translate(13 13)"
  }, E.createElement("path", {
    d: "M22 3.701h-1.642V1.644l-2.06-.001V0h2.538c.421 0 .682.174.827.32.322.322.337.748.337.83v2.551z"
  }), E.createElement("path", {
    d: "M1.643 3.701H0V1.165C0 .743.174.482.32.336.64.016 1.06 0 1.147 0H3.701v1.643H1.644l-.001 2.058z"
  }), E.createElement("path", {
    d: "M13.7232174 1.5486087L17.4249565 1.5486087 17.4249565 0 13.7232174 0z"
  }), E.createElement("path", {
    d: "M9.15008696 1.5486087L12.8508696 1.5486087 12.8508696 0 9.15008696 0z"
  }), E.createElement("path", {
    d: "M4.57504348 1.5486087L8.27678261 1.5486087 8.27678261 0 4.57504348 0z"
  }), E.createElement("path", {
    d: "M0 8.27582609L1.5486087 8.27582609 1.5486087 4.57504348 0 4.57504348z"
  }), E.createElement("path", {
    d: "M20.4513913 8.27582609L22 8.27582609 22 4.57504348 20.4513913 4.57504348z"
  }), E.createElement("path", {
    d: "M0 12.8508696L1.5486087 12.8508696 1.5486087 9.14913043 0 9.14913043z"
  }), E.createElement("path", {
    d: "M0 17.4249565L1.5486087 17.4249565 1.5486087 13.7232174 0 13.7232174z"
  }), E.createElement("path", {
    d: "M20.4513913 12.8508696L22 12.8508696 22 9.14913043 20.4513913 9.14913043z"
  }), E.createElement("path", {
    d: "M20.4513913 17.4249565L22 17.4249565 22 13.7232174 20.4513913 13.7232174z"
  }), E.createElement("path", {
    d: "M3.702 22H1.165c-.421 0-.682-.174-.828-.32-.322-.322-.337-.748-.337-.83v-2.552h1.643v2.059h2.059V22z"
  }), E.createElement("path", {
    d: "M20.853 22h-2.554v-1.642h2.057l.001-2.06H22v2.538c0 .42-.174.682-.319.827-.32.32-.742.337-.828.337"
  }), E.createElement("path", {
    d: "M4.57504348 22L8.27678261 22 8.27678261 20.4513913 4.57504348 20.4513913z"
  }), E.createElement("path", {
    d: "M9.15008696 22L12.8508696 22 12.8508696 20.4513913 9.15008696 20.4513913z"
  }), E.createElement("path", {
    d: "M13.7232174 22L17.4249565 22 17.4249565 20.4513913 13.7232174 20.4513913z"
  }))));
},
    Ir = ds;

import te from "react";

var hs = function hs(_ref7) {
  var _ref7$highlight = _ref7.highlight,
      t = _ref7$highlight === void 0 ? "currentColor" : _ref7$highlight,
      _ref7$width = _ref7.width,
      o = _ref7$width === void 0 ? 48 : _ref7$width,
      _ref7$height = _ref7.height,
      e = _ref7$height === void 0 ? 48 : _ref7$height;
  return te.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: e,
    viewBox: "0 0 48 48"
  }, te.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, te.createElement("path", {
    fill: t,
    d: "M29.967 13.005L26.984 13c-3.35 0-5.516 2.222-5.516 5.66v2.61h-2.999c-.26 0-.469.21-.469.47v3.78c0 .26.21.47.469.47h2.999v9.541c0 .26.21.469.469.469h3.912c.26 0 .47-.21.47-.469V25.99h3.506c.259 0 .469-.21.469-.47l.001-3.78a.47.47 0 00-.469-.47h-3.508v-2.212c0-1.064.254-1.603 1.639-1.603l2.01-.001c.258 0 .468-.21.468-.47v-3.51a.47.47 0 00-.468-.47z"
  })));
},
    Er = hs;

import Qt from "react";

var fs = function fs(_ref8) {
  var _ref8$highlight = _ref8.highlight,
      t = _ref8$highlight === void 0 ? "currentColor" : _ref8$highlight,
      _ref8$width = _ref8.width,
      o = _ref8$width === void 0 ? 48 : _ref8$width,
      _ref8$height = _ref8.height,
      e = _ref8$height === void 0 ? 48 : _ref8$height;
  return Qt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: e,
    viewBox: "0 0 48 48"
  }, Qt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Qt.createElement("g", {
    fill: t,
    transform: "translate(13 13)"
  }, Qt.createElement("path", {
    d: "M15.125 0h-8.25A6.876 6.876 0 000 6.875v8.25A6.876 6.876 0 006.875 22h8.25A6.876 6.876 0 0022 15.125v-8.25A6.876 6.876 0 0015.125 0zm4.813 15.125a4.818 4.818 0 01-4.813 4.813h-8.25a4.818 4.818 0 01-4.813-4.813v-8.25a4.818 4.818 0 014.813-4.813h8.25a4.818 4.818 0 014.813 4.813v8.25z"
  }), Qt.createElement("path", {
    d: "M11 5.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 8.938A3.442 3.442 0 017.562 11 3.441 3.441 0 0111 7.562 3.441 3.441 0 0114.438 11 3.442 3.442 0 0111 14.438z"
  }), Qt.createElement("circle", {
    cx: "16.913",
    cy: "5.088",
    r: "1"
  }))));
},
    Hr = fs;

import oe from "react";

var us = function us(_ref9) {
  var _ref9$highlight = _ref9.highlight,
      t = _ref9$highlight === void 0 ? "currentColor" : _ref9$highlight,
      _ref9$width = _ref9.width,
      o = _ref9$width === void 0 ? 48 : _ref9$width,
      _ref9$height = _ref9.height,
      e = _ref9$height === void 0 ? 48 : _ref9$height;
  return oe.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: e,
    viewBox: "0 0 48 48"
  }, oe.createElement("g", {
    fill: "none",
    fillOpacity: "0.9",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, oe.createElement("path", {
    fill: t,
    d: "M36 17.305c-.892.402-1.843.668-2.835.797a4.997 4.997 0 002.165-2.79 9.685 9.685 0 01-3.12 1.222 4.874 4.874 0 00-3.595-1.596c-2.723 0-4.916 2.267-4.916 5.047 0 .4.032.785.113 1.151-4.09-.205-7.71-2.215-10.141-5.278a5.18 5.18 0 00-.673 2.55c0 1.748.877 3.297 2.185 4.194a4.766 4.766 0 01-2.223-.621v.055c0 2.452 1.705 4.49 3.942 4.958-.4.113-.837.167-1.29.167-.315 0-.633-.019-.931-.087.637 1.999 2.446 3.468 4.597 3.516a9.73 9.73 0 01-6.1 2.152c-.404 0-.791-.018-1.178-.07a13.601 13.601 0 007.548 2.266c9.054 0 14.004-7.693 14.004-14.36 0-.224-.008-.439-.018-.653A9.958 9.958 0 0036 17.305z"
  })));
},
    Or = us;

import gs from "styled-components";
var vs = gs.svg.attrs({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
})(_templateObject55()),
    U = vs;
import B from "react";

var bs = function bs(_ref10) {
  var _ref10$highlight = _ref10.highlight,
      t = _ref10$highlight === void 0 ? "#565656" : _ref10$highlight,
      _ref10$width = _ref10.width,
      o = _ref10$width === void 0 ? 32 : _ref10$width,
      _ref10$height = _ref10.height,
      e = _ref10$height === void 0 ? 32 : _ref10$height;
  return B.createElement(U, {
    width: o,
    height: e,
    viewBox: "0 0 32 32"
  }, B.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, B.createElement("g", {
    fill: t,
    transform: "translate(-8 -8)"
  }, B.createElement("g", {
    transform: "translate(8 8)"
  }, B.createElement("g", null, B.createElement("path", {
    d: "M.941 31.992h2.824v-.94L.941 31.05v-2.822h-.94v2.846s-.004.918.94.918"
  }), B.createElement("path", {
    d: "M31.974 31.051v-2.823h-.942v2.823h-2.823v.941h2.846s.919.003.919-.94"
  }), B.createElement("path", {
    d: "M4.62305882 31.9926588L8.38776471 31.9926588 8.38776471 31.0514824 4.62305882 31.0514824z"
  }), B.createElement("path", {
    d: "M9.32894118 31.9926588L13.0936471 31.9926588 13.0936471 31.0514824 9.32894118 31.0514824z"
  }), B.createElement("path", {
    d: "M14.0348235 31.9926588L17.7995294 31.9926588 17.7995294 31.0514824 14.0348235 31.0514824z"
  }), B.createElement("path", {
    d: "M18.7407059 31.9926588L22.5054118 31.9926588 22.5054118 31.0514824 18.7407059 31.0514824z"
  }), B.createElement("path", {
    d: "M23.4465882 31.9926588L27.2112941 31.9926588 27.2112941 31.0514824 23.4465882 31.0514824z"
  }), B.createElement("path", {
    d: "M0 .94v2.824h.941L.942.941h2.823V0H.919S0-.002 0 .94"
  }), B.createElement("path", {
    d: "M31.032 0H28.21v.94l2.823.002v2.822h.942V.92s.002-.92-.942-.92"
  }), B.createElement("path", {
    d: "M4.62305882 0.940423529L8.38776471 0.940423529 8.38776471 -0.000752941176 4.62305882 -0.000752941176z"
  }), B.createElement("path", {
    d: "M9.32894118 0.940423529L13.0936471 0.940423529 13.0936471 -0.000752941176 9.32894118 -0.000752941176z"
  }), B.createElement("path", {
    d: "M14.0348235 0.940423529L17.7995294 0.940423529 17.7995294 -0.000752941176 14.0348235 -0.000752941176z"
  }), B.createElement("path", {
    d: "M18.7407059 0.940423529L22.5054118 0.940423529 22.5054118 -0.000752941176 18.7407059 -0.000752941176z"
  }), B.createElement("path", {
    d: "M23.4465882 0.940423529L27.2112941 0.940423529 27.2112941 -0.000752941176 23.4465882 -0.000752941176z"
  }), B.createElement("path", {
    d: "M0 8.46324706L0.941176471 8.46324706 0.941176471 4.69854118 0 4.69854118z"
  }), B.createElement("path", {
    d: "M0 13.1691294L0.941176471 13.1691294 0.941176471 9.40442353 0 9.40442353z"
  }), B.createElement("path", {
    d: "M0 17.8750118L0.941176471 17.8750118 0.941176471 14.1103059 0 14.1103059z"
  }), B.createElement("path", {
    d: "M0 22.5808941L0.941176471 22.5808941 0.941176471 18.8161882 0 18.8161882z"
  }), B.createElement("path", {
    d: "M0 27.2867765L0.941176471 27.2867765 0.941176471 23.5220706 0 23.5220706z"
  }), B.createElement("path", {
    d: "M30.976 8.46324706L31.9171765 8.46324706 31.9171765 4.69854118 30.976 4.69854118z"
  }), B.createElement("path", {
    d: "M30.976 13.1691294L31.9171765 13.1691294 31.9171765 9.40442353 30.976 9.40442353z"
  }), B.createElement("path", {
    d: "M30.976 17.8750118L31.9171765 17.8750118 31.9171765 14.1103059 30.976 14.1103059z"
  }), B.createElement("path", {
    d: "M30.976 22.5808941L31.9171765 22.5808941 31.9171765 18.8161882 30.976 18.8161882z"
  }), B.createElement("path", {
    d: "M30.976 27.2867765L31.9171765 27.2867765 31.9171765 23.5220706 30.976 23.5220706z"
  }))))));
},
    Fr = bs;

import Io from "react";

var xs = function xs(_ref11) {
  var _ref11$highlight = _ref11.highlight,
      t = _ref11$highlight === void 0 ? "#565656" : _ref11$highlight,
      _ref11$width = _ref11.width,
      o = _ref11$width === void 0 ? 32 : _ref11$width,
      _ref11$height = _ref11.height,
      e = _ref11$height === void 0 ? 48 : _ref11$height;
  return Io.createElement(U, {
    width: o,
    height: e,
    viewBox: "0 0 42 32"
  }, Io.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Io.createElement("g", {
    fill: t,
    transform: "translate(-3 -8)"
  }, Io.createElement("rect", {
    width: "42",
    height: "32",
    x: "3",
    y: "8",
    rx: "0.5"
  }))));
},
    Wr = xs;

import Eo from "react";

var Cs = function Cs(_ref12) {
  var _ref12$highlight = _ref12.highlight,
      t = _ref12$highlight === void 0 ? "#565656" : _ref12$highlight,
      _ref12$width = _ref12.width,
      o = _ref12$width === void 0 ? 26 : _ref12$width,
      _ref12$height = _ref12.height,
      e = _ref12$height === void 0 ? 46 : _ref12$height;
  return Eo.createElement(U, {
    width: o,
    height: e,
    viewBox: "0 0 26 46"
  }, Eo.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Eo.createElement("g", {
    fill: t,
    transform: "translate(-11 -1)"
  }, Eo.createElement("path", {
    d: "M1 11.496A.5.5 0 011.5 11h45a.5.5 0 01.5.496v25.008a.5.5 0 01-.5.496h-45a.5.5 0 01-.5-.496V11.496z",
    transform: "rotate(90 24 24)"
  }))));
},
    Vr = Cs;

import Ho from "react";

var ws = function ws(_ref13) {
  var _ref13$highlight = _ref13.highlight,
      t = _ref13$highlight === void 0 ? "#565656" : _ref13$highlight,
      _ref13$width = _ref13.width,
      o = _ref13$width === void 0 ? 26 : _ref13$width,
      _ref13$height = _ref13.height,
      e = _ref13$height === void 0 ? 46 : _ref13$height;
  return Ho.createElement(U, {
    width: o,
    height: e,
    viewBox: "0 0 26 46"
  }, Ho.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Ho.createElement("g", {
    fill: t,
    transform: "translate(-11 -1)"
  }, Ho.createElement("path", {
    d: "M1 11.496A.5.5 0 011.5 11h45a.5.5 0 01.5.496v25.008a.5.5 0 01-.5.496h-45a.5.5 0 01-.5-.496V11.496z"
  }))));
},
    Nr = ws;

import ot from "react";

var ks = function ks(_ref14) {
  var _ref14$highlight = _ref14.highlight,
      t = _ref14$highlight === void 0 ? "#565656" : _ref14$highlight,
      _ref14$mask = _ref14.mask,
      o = _ref14$mask === void 0 ? "#fff" : _ref14$mask,
      _ref14$width = _ref14.width,
      e = _ref14$width === void 0 ? 32 : _ref14$width,
      _ref14$height = _ref14.height,
      r = _ref14$height === void 0 ? 32 : _ref14$height;
  return ot.createElement(U, {
    width: e,
    height: r,
    viewBox: "0 0 32 32"
  }, ot.createElement("defs", null, ot.createElement("rect", {
    id: "photoeditorsdk-square-icon",
    width: "32",
    height: "32",
    x: "0.92",
    y: "0.707",
    rx: "1"
  })), ot.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, ot.createElement("g", {
    transform: "translate(-8 -8)"
  }, ot.createElement("g", {
    transform: "translate(7.08 7.293)"
  }, ot.createElement("mask", {
    fill: o
  }, ot.createElement("use", {
    xlinkHref: "#photoeditorsdk-square-icon"
  })), ot.createElement("use", {
    fill: t,
    xlinkHref: "#photoeditorsdk-square-icon"
  })))));
},
    Ur = ks;

import Oo from "react";

var ys = function ys(_ref15) {
  var _ref15$highlight = _ref15.highlight,
      t = _ref15$highlight === void 0 ? "#565656" : _ref15$highlight,
      _ref15$width = _ref15.width,
      o = _ref15$width === void 0 ? 32 : _ref15$width,
      _ref15$height = _ref15.height,
      e = _ref15$height === void 0 ? 42 : _ref15$height;
  return Oo.createElement(U, {
    width: o,
    height: e,
    viewBox: "0 0 32 42"
  }, Oo.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Oo.createElement("g", {
    fill: t,
    transform: "translate(-8 -3)"
  }, Oo.createElement("rect", {
    width: "42",
    height: "32",
    x: "3",
    y: "8",
    rx: "0.5",
    transform: "rotate(90 24 24)"
  }))));
},
    Kr = ys;

import et from "react";

var Ss = function Ss(_ref16) {
  var _ref16$main = _ref16.main,
      t = _ref16$main === void 0 ? "#424242" : _ref16$main,
      _ref16$highlight = _ref16.highlight,
      o = _ref16$highlight === void 0 ? "#565656" : _ref16$highlight,
      _ref16$width = _ref16.width,
      e = _ref16$width === void 0 ? "48px" : _ref16$width,
      _ref16$height = _ref16.height,
      r = _ref16$height === void 0 ? "48px" : _ref16$height;
  return et.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, et.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, et.createElement("rect", {
    width: "28",
    height: "3",
    x: "12",
    y: "41",
    fill: t,
    rx: "0.5",
    transform: "matrix(-1 0 0 1 52 0)"
  }), et.createElement("rect", {
    width: "34",
    height: "28",
    x: "7",
    y: "8",
    fill: o,
    rx: "0.5",
    transform: "matrix(1 0 0 -1 0 44)"
  }), et.createElement("rect", {
    width: "3",
    height: "3",
    x: "8",
    y: "41",
    fill: t,
    rx: "0.5",
    transform: "matrix(-1 0 0 1 19 0)"
  }), et.createElement("rect", {
    width: "28",
    height: "3",
    x: "12",
    y: "37",
    fill: t,
    rx: "0.5",
    transform: "matrix(-1 0 0 1 52 0)"
  }), et.createElement("rect", {
    width: "28",
    height: "3",
    x: "12",
    y: "4",
    fill: t,
    rx: "0.5",
    transform: "matrix(1 0 0 -1 0 11)"
  }), et.createElement("rect", {
    width: "3",
    height: "3",
    x: "8",
    y: "37",
    fill: t,
    rx: "0.5",
    transform: "matrix(-1 0 0 1 19 0)"
  }), et.createElement("rect", {
    width: "3",
    height: "3",
    x: "8",
    y: "4",
    fill: t,
    rx: "0.5",
    transform: "matrix(1 0 0 -1 0 11)"
  })));
},
    Xr = Ss;

import rt from "react";

var Ds = function Ds(_ref17) {
  var _ref17$main = _ref17.main,
      t = _ref17$main === void 0 ? "#424242" : _ref17$main,
      _ref17$highlight = _ref17.highlight,
      o = _ref17$highlight === void 0 ? "#565656" : _ref17$highlight,
      _ref17$width = _ref17.width,
      e = _ref17$width === void 0 ? "48px" : _ref17$width,
      _ref17$height = _ref17.height,
      r = _ref17$height === void 0 ? "48px" : _ref17$height;
  return rt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, rt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, rt.createElement("g", null, rt.createElement("path", {
    fill: t,
    d: "M42 5a1 1 0 011 1v13a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h36zM21.505 18h-2.01a.494.494 0 00-.495.5c0 .268.222.5.495.5h2.01c.28 0 .495-.224.495-.5l-.008-.088a.503.503 0 00-.487-.412zm8.004 0h-5.018a.5.5 0 000 1h5.018a.5.5 0 00.491-.5l-.008-.088A.5.5 0 0029.51 18z"
  }), rt.createElement("rect", {
    width: "22",
    height: "11",
    x: "20",
    y: "29",
    fill: t,
    rx: "1"
  }), rt.createElement("rect", {
    width: "13",
    height: "10",
    x: "6",
    y: "23",
    fill: t,
    rx: "1"
  }), rt.createElement("rect", {
    width: "22",
    height: "5",
    x: "20",
    y: "23",
    fill: t,
    rx: "1"
  }), rt.createElement("rect", {
    width: "7",
    height: "7",
    x: "9",
    y: "14",
    fill: o,
    rx: "1"
  }), rt.createElement("rect", {
    width: "13",
    height: "9",
    x: "6",
    y: "34",
    fill: t,
    rx: "1"
  }))));
},
    $r = Ds;

import nt from "react";

var Ts = function Ts(_ref18) {
  var _ref18$main = _ref18.main,
      t = _ref18$main === void 0 ? "#424242" : _ref18$main,
      _ref18$highlight = _ref18.highlight,
      o = _ref18$highlight === void 0 ? "#565656" : _ref18$highlight,
      _ref18$width = _ref18.width,
      e = _ref18$width === void 0 ? "48px" : _ref18$width,
      _ref18$height = _ref18.height,
      r = _ref18$height === void 0 ? "48px" : _ref18$height;
  return nt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, nt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, nt.createElement("g", {
    transform: "translate(5 5)"
  }, nt.createElement("path", {
    fill: o,
    d: "M37 0a1 1 0 011 1v13a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h36zM16.505 13h-2.01a.494.494 0 00-.495.5c0 .268.222.5.495.5h2.01c.28 0 .495-.224.495-.5l-.008-.088a.503.503 0 00-.487-.412zm8.004 0h-5.018a.5.5 0 000 1h5.018a.5.5 0 00.491-.5l-.008-.088A.5.5 0 0024.51 13z"
  }), nt.createElement("rect", {
    width: "22",
    height: "11",
    x: "15",
    y: "24",
    fill: t,
    rx: "1"
  }), nt.createElement("rect", {
    width: "13",
    height: "10",
    x: "1",
    y: "18",
    fill: t,
    rx: "1"
  }), nt.createElement("rect", {
    width: "22",
    height: "5",
    x: "15",
    y: "18",
    fill: t,
    rx: "1"
  }), nt.createElement("rect", {
    width: "7",
    height: "7",
    x: "4",
    y: "9",
    fill: t,
    rx: "1"
  }), nt.createElement("rect", {
    width: "13",
    height: "9",
    x: "1",
    y: "29",
    fill: t,
    rx: "1"
  }))));
},
    Gr = Ts;

import wt from "react";

var Bs = function Bs(_ref19) {
  var _ref19$main = _ref19.main,
      t = _ref19$main === void 0 ? "#424242" : _ref19$main,
      _ref19$highlight = _ref19.highlight,
      o = _ref19$highlight === void 0 ? "#565656" : _ref19$highlight,
      _ref19$width = _ref19.width,
      e = _ref19$width === void 0 ? "48px" : _ref19$width,
      _ref19$height = _ref19.height,
      r = _ref19$height === void 0 ? "48px" : _ref19$height;
  return wt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, wt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, wt.createElement("rect", {
    width: "26",
    height: "7",
    x: "7",
    y: "18",
    fill: t,
    rx: "1"
  }), wt.createElement("rect", {
    width: "9",
    height: "7",
    x: "34",
    y: "11",
    fill: t,
    rx: "1"
  }), wt.createElement("rect", {
    width: "9",
    height: "8",
    x: "34",
    y: "19",
    fill: t,
    rx: "1"
  }), wt.createElement("rect", {
    width: "3",
    height: "3",
    x: "40",
    y: "6",
    fill: t,
    rx: "1"
  }), wt.createElement("rect", {
    width: "26",
    height: "21",
    x: "7",
    y: "27",
    fill: t,
    rx: "1"
  }), wt.createElement("rect", {
    width: "26",
    height: "16",
    x: "7",
    y: "5",
    fill: o,
    rx: "1"
  })));
},
    jr = Bs;

import kt from "react";

var Ms = function Ms(_ref20) {
  var _ref20$main = _ref20.main,
      t = _ref20$main === void 0 ? "#424242" : _ref20$main,
      _ref20$highlight = _ref20.highlight,
      o = _ref20$highlight === void 0 ? "#565656" : _ref20$highlight,
      _ref20$width = _ref20.width,
      e = _ref20$width === void 0 ? "48px" : _ref20$width,
      _ref20$height = _ref20.height,
      r = _ref20$height === void 0 ? "48px" : _ref20$height;
  return kt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, kt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, kt.createElement("rect", {
    width: "26",
    height: "7",
    x: "7",
    y: "34",
    fill: t,
    rx: "1"
  }), kt.createElement("rect", {
    width: "26",
    height: "32",
    x: "7",
    y: "5",
    fill: o,
    rx: "1"
  }), kt.createElement("rect", {
    width: "9",
    height: "7",
    x: "34",
    y: "11",
    fill: t,
    rx: "1"
  }), kt.createElement("rect", {
    width: "9",
    height: "8",
    x: "34",
    y: "19",
    fill: t,
    rx: "1"
  }), kt.createElement("rect", {
    width: "3",
    height: "3",
    x: "40",
    y: "6",
    fill: t,
    rx: "1"
  }), kt.createElement("rect", {
    width: "26",
    height: "5",
    x: "7",
    y: "43",
    fill: t,
    rx: "1"
  })));
},
    Zr = Ms;

import yt from "react";

var zs = function zs(_ref21) {
  var _ref21$main = _ref21.main,
      t = _ref21$main === void 0 ? "#424242" : _ref21$main,
      _ref21$highlight = _ref21.highlight,
      o = _ref21$highlight === void 0 ? "#565656" : _ref21$highlight,
      _ref21$width = _ref21.width,
      e = _ref21$width === void 0 ? "48px" : _ref21$width,
      _ref21$height = _ref21.height,
      r = _ref21$height === void 0 ? "48px" : _ref21$height;
  return yt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, yt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, yt.createElement("rect", {
    width: "26",
    height: "7",
    x: "7",
    y: "28",
    fill: t,
    rx: "1"
  }), yt.createElement("rect", {
    width: "26",
    height: "26",
    x: "7",
    y: "5",
    fill: o,
    rx: "1"
  }), yt.createElement("rect", {
    width: "9",
    height: "7",
    x: "34",
    y: "11",
    fill: t,
    rx: "1"
  }), yt.createElement("rect", {
    width: "9",
    height: "8",
    x: "34",
    y: "19",
    fill: t,
    rx: "1"
  }), yt.createElement("rect", {
    width: "3",
    height: "3",
    x: "40",
    y: "6",
    fill: t,
    rx: "1"
  }), yt.createElement("rect", {
    width: "26",
    height: "11",
    x: "7",
    y: "37",
    fill: t,
    rx: "1"
  })));
},
    Yr = zs;

import Fo from "react";

var Ls = function Ls(_ref22) {
  var _ref22$main = _ref22.main,
      t = _ref22$main === void 0 ? "#424242" : _ref22$main,
      _ref22$highlight = _ref22.highlight,
      o = _ref22$highlight === void 0 ? "#565656" : _ref22$highlight,
      _ref22$width = _ref22.width,
      e = _ref22$width === void 0 ? "48px" : _ref22$width,
      _ref22$height = _ref22.height,
      r = _ref22$height === void 0 ? "48px" : _ref22$height;
  return Fo.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, Fo.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Fo.createElement("rect", {
    width: "20",
    height: "34",
    x: "14",
    y: "10",
    fill: o,
    rx: "1.5"
  }), Fo.createElement("rect", {
    width: "3",
    height: "3",
    x: "14",
    y: "5",
    fill: t,
    rx: "1"
  })));
},
    Jr = Ls;

import N from "react";

var As = function As(_ref23) {
  var _ref23$main = _ref23.main,
      t = _ref23$main === void 0 ? "#424242" : _ref23$main,
      _ref23$highlight = _ref23.highlight,
      o = _ref23$highlight === void 0 ? "#565656" : _ref23$highlight,
      _ref23$shadow = _ref23.shadow,
      e = _ref23$shadow === void 0 ? "#333333" : _ref23$shadow,
      _ref23$width = _ref23.width,
      r = _ref23$width === void 0 ? "48px" : _ref23$width,
      _ref23$height = _ref23.height,
      n = _ref23$height === void 0 ? "48px" : _ref23$height;
  return N.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: n,
    viewBox: "0 0 48 48"
  }, N.createElement("defs", null, N.createElement("filter", {
    id: "photoeditorsdk-twitter-post-icon",
    width: "166.7%",
    height: "166.7%",
    x: "-33.3%",
    y: "-33.3%",
    filterUnits: "objectBoundingBox"
  }, N.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: "1"
  }))), N.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, N.createElement("rect", {
    width: "38",
    height: "15",
    x: "5",
    y: "5",
    fill: t,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "24",
    fill: t,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "26",
    fill: t,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "28",
    fill: t,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "26",
    height: "13",
    x: "17",
    y: "24",
    fill: o,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "26",
    height: "3",
    x: "17",
    y: "38",
    fill: t,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "26",
    height: "3",
    x: "17",
    y: "42",
    fill: t,
    rx: "0.5"
  }), N.createElement("rect", {
    width: "9",
    height: "9",
    x: "8",
    y: "13",
    fill: e,
    filter: "url(#photoeditorsdk-twitter-post-icon)",
    rx: "1"
  }), N.createElement("rect", {
    width: "7",
    height: "7",
    x: "9",
    y: "14",
    fill: t,
    rx: "1"
  })));
},
    qr = As;

import q from "react";

var Ps = function Ps(_ref24) {
  var _ref24$main = _ref24.main,
      t = _ref24$main === void 0 ? "#424242" : _ref24$main,
      _ref24$highlight = _ref24.highlight,
      o = _ref24$highlight === void 0 ? "#565656" : _ref24$highlight,
      _ref24$width = _ref24.width,
      e = _ref24$width === void 0 ? "48px" : _ref24$width,
      _ref24$height = _ref24.height,
      r = _ref24$height === void 0 ? "48px" : _ref24$height;
  return q.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, q.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, q.createElement("rect", {
    width: "38",
    height: "15",
    x: "5",
    y: "5",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "24",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "26",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "28",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "26",
    height: "13",
    x: "17",
    y: "24",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "26",
    height: "3",
    x: "17",
    y: "38",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "26",
    height: "3",
    x: "17",
    y: "42",
    fill: t,
    rx: "0.5"
  }), q.createElement("rect", {
    width: "7",
    height: "7",
    x: "9",
    y: "14",
    fill: o,
    rx: "1"
  })));
},
    Qr = Ps;

import Q from "react";

var Is = function Is(_ref25) {
  var _ref25$main = _ref25.main,
      t = _ref25$main === void 0 ? "#424242" : _ref25$main,
      _ref25$highlight = _ref25.highlight,
      o = _ref25$highlight === void 0 ? "#565656" : _ref25$highlight,
      _ref25$width = _ref25.width,
      e = _ref25$width === void 0 ? "48px" : _ref25$width,
      _ref25$height = _ref25.height,
      r = _ref25$height === void 0 ? "48px" : _ref25$height;
  return Q.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 48 48"
  }, Q.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Q.createElement("rect", {
    width: "38",
    height: "15",
    x: "5",
    y: "5",
    fill: o,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "24",
    fill: t,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "26",
    fill: t,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "11",
    height: "1",
    x: "5",
    y: "28",
    fill: t,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "26",
    height: "13",
    x: "17",
    y: "24",
    fill: t,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "26",
    height: "3",
    x: "17",
    y: "38",
    fill: t,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "26",
    height: "3",
    x: "17",
    y: "42",
    fill: t,
    rx: "0.5"
  }), Q.createElement("rect", {
    width: "7",
    height: "7",
    x: "9",
    y: "14",
    fill: t,
    rx: "1"
  })));
},
    _r = Is;

import Kt from "react";

var Es = function Es() {
  return Kt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, Kt.createElement("defs", null, Kt.createElement("path", {
    id: "photoeditorsdk-delete-icon",
    d: "M20 6l-2.312 15.718A1.5 1.5 0 0116.204 23H5.796a1.5 1.5 0 01-1.484-1.282L2 6h18zM7 1a1 1 0 011-1h6a1 1 0 011 1v1h7v2H0V2h7V1z"
  })), Kt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Kt.createElement("mask", {
    fill: "currentColor"
  }, Kt.createElement("use", {
    xlinkHref: "#photoeditorsdk-delete-icon"
  })), Kt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-delete-icon"
  })));
},
    Rr = Es;

import X from "react";

var Hs = function Hs(_ref26) {
  var _ref26$height = _ref26.height,
      t = _ref26$height === void 0 ? 3 : _ref26$height,
      _ref26$width = _ref26.width,
      o = _ref26$width === void 0 ? 102 : _ref26$width,
      _ref26$x = _ref26.x,
      e = _ref26$x === void 0 ? -102 : _ref26$x,
      r = _ref26.className,
      n = _ref26.style;
  return X.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: t,
    viewBox: "0 0 102 3",
    className: r,
    style: n
  }, X.createElement("pattern", {
    id: "photoeditorsdk-slider-dots",
    fill: "currentColor",
    patternUnits: "userSpaceOnUse",
    width: "102",
    height: "3"
  }, X.createElement("rect", {
    width: "3",
    height: "3",
    x: "99",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "88",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "77",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "66",
    y: "0",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "55",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "44",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "33",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "22",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), X.createElement("rect", {
    width: "3",
    height: "3",
    x: "11",
    y: "0",
    rx: "1.5"
  })), X.createElement("rect", {
    fill: "url(#photoeditorsdk-slider-dots)",
    x: -o * 1.5,
    y: "0",
    width: o * 4,
    height: "3",
    transform: "translate(".concat(e, ", 0)")
  }));
},
    tn = Hs;

import Xt from "react";

var Os = function Os() {
  return Xt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, Xt.createElement("defs", null, Xt.createElement("path", {
    id: "photoeditorsdk-duplicate-icon",
    d: "M3.429 8.571v12h12v-12h-12zM1.714 5.143h15.429c.947 0 1.714.767 1.714 1.714v15.429c0 .946-.767 1.714-1.714 1.714H1.714A1.714 1.714 0 010 22.286V6.857c0-.947.768-1.714 1.714-1.714zM22.286 0C23.232 0 24 .768 24 1.714v15.429c0 .947-.768 1.714-1.714 1.714H20.57V3.429L5.142 3.428V1.714C5.143.768 5.91 0 6.858 0h15.429z"
  })), Xt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, Xt.createElement("mask", {
    fill: "currentColor"
  }, Xt.createElement("use", {
    xlinkHref: "#photoeditorsdk-duplicate-icon"
  })), Xt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-duplicate-icon"
  })));
},
    on = Os;

import en from "react";

var Fs = function Fs() {
  return en.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, en.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    d: "M2.087 7.115h7.66v15.32h5.027l.223-15.32h7.438V2.087H2.087v5.028zM14.075 24h-4.15a2.42 2.42 0 01-1.718-.711 2.423 2.423 0 01-.711-1.717V9.01H2.429c-.67 0-1.278-.273-1.718-.713A2.426 2.426 0 010 6.579V2.43C0 1.76.272 1.153.711.713A2.424 2.424 0 012.43 0h19.142c.671 0 1.278.272 1.718.713.439.44.711 1.047.711 1.718v4.148c0 .671-.272 1.278-.711 1.718-.44.44-1.047.713-1.718.713h-5.067v12.562c0 .67-.272 1.278-.711 1.717a2.42 2.42 0 01-1.718.711z"
  }));
},
    rn = Fs;

import St from "react";

var Ws = function Ws(_ref27) {
  var t = _ref27.className;
  return St.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 15 14",
    transform: "scale(-1, 1)",
    className: t
  }, St.createElement("title", null, "Flip Horizontal"), St.createElement("defs", null, St.createElement("path", {
    id: "photoeditorsdk-flip-horizontal-icon",
    d: "M42 1v14h-1.167v-1.167H37a2 2 0 01-2-2V4.167a2 2 0 012-2l3.833-.001V1H42zm5.833 11.958a.875.875 0 01-.875.875h-3.791v-1.166l3.499-.001V3.333h-3.5V2.167h3.792c.446 0 .815.333.869.765l.006.11v9.916z"
  })), St.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(-34 -1)"
  }, St.createElement("mask", {
    fill: "none"
  }, St.createElement("use", {
    xlinkHref: "#photoeditorsdk-flip-horizontal-icon"
  })), St.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-flip-horizontal-icon"
  })));
},
    nn = Ws;

import Dt from "react";

var Vs = function Vs(_ref28) {
  var t = _ref28.className;
  return Dt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 15 14",
    className: t
  }, Dt.createElement("title", null, "Flip Vertical"), Dt.createElement("defs", null, Dt.createElement("path", {
    id: "photoeditorsdk-flip-vertical-icon",
    d: "M42 1v14h-1.167v-1.167H37a2 2 0 01-2-2V4.167a2 2 0 012-2l3.833-.001V1H42zm5.833 11.958a.875.875 0 01-.875.875h-3.791v-1.166l3.499-.001V3.333h-3.5V2.167h3.792c.446 0 .815.333.869.765l.006.11v9.916z"
  })), Dt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(-34 -1)"
  }, Dt.createElement("mask", {
    fill: "none"
  }, Dt.createElement("use", {
    xlinkHref: "#photoeditorsdk-flip-vertical-icon"
  })), Dt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    transform: "rotate(-90 41.417 8)",
    xlinkHref: "#photoeditorsdk-flip-vertical-icon"
  })));
},
    sn = Vs;

import Tt from "react";

var Ns = function Ns(_ref29) {
  var _ref29$alt = _ref29.alt,
      t = _ref29$alt === void 0 ? "Rotate" : _ref29$alt,
      o = _ref29.className;
  return Tt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 16 16",
    className: o
  }, Tt.createElement("title", null, t), Tt.createElement("defs", null, Tt.createElement("path", {
    id: "photoeditorsdk-rotate-icon",
    d: "M132 0l1.25 1.57a8.01 8.01 0 0110.41.77 8.015 8.015 0 010 11.32c-.33.33-.67.62-1.04.859-1.38.991-3 1.481-4.62 1.481v-2c1.22 0 2.44-.37 3.47-1.111a6 6 0 00.77-9.129 5.992 5.992 0 00-7.73-.63L136 5h-5l1-5zm2.43 12.82c.5.38 1.06.67 1.66.87l-.64 1.89a7.56 7.56 0 01-1.48-.67l-.03-.01v-.01h-.02v-.01h-.01c0-.01-.01-.01-.01-.01h-.01v-.01h-.02v-.01h-.01l-.01-.01s-.01 0-.01-.01h-.01c-.2-.12-.4-.26-.6-.4zm-2.15-3.02c.18.6.47 1.17.83 1.68l-1.63 1.16v-.01s-.01 0-.01-.01c0 0 0-.01-.01-.01v-.01h-.01v-.01c-.01 0-.01-.01-.01-.01v-.01h-.01v-.01h-.01v-.01c0-.01-.01-.01-.01-.01v-.01c-.01 0-.01 0-.01-.01-.27-.39-.49-.79-.68-1.21-.01 0-.01-.01-.01-.01v-.01h-.01v-.02l-.01-.01c0-.02-.01-.02-.01-.02v-.02h-.01v-.02h-.01v-.03h-.01v-.02h-.01v-.02c-.01 0-.01 0-.01-.01v-.01c-.1-.23-.19-.47-.26-.7z"
  })), Tt.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(-130)"
  }, Tt.createElement("mask", {
    fill: "none"
  }, Tt.createElement("use", {
    xlinkHref: "#photoeditorsdk-rotate-icon"
  })), Tt.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-rotate-icon"
  })));
},
    an = Ns;

var _m = {
  adjustment: wr,
  filter: yr,
  library: Tr,
  overlay: Br,
  focus: Sr,
  sticker: Mr,
  text: zr,
  textdesign: Lr,
  frame: Dr,
  transform: Ar,
  brush: kr
},
    Rm = {
  left: xr,
  right: Cr,
  center: br
};
var uo = {
  undo: vr,
  redo: gr,
  close: fr,
  export: ur
},
    M = {
  categories: (_categories = {}, _defineProperty(_categories, P.CommonCategory, Ir), _defineProperty(_categories, P.FacebookCategory, Er), _defineProperty(_categories, P.TwitterCategory, Or), _defineProperty(_categories, P.InstagramCategory, Hr), _categories),
  crops: (_crops = {}, _defineProperty(_crops, P.Custom, Fr), _defineProperty(_crops, P.Square, Ur), _defineProperty(_crops, P.ThreeByFour, Kr), _defineProperty(_crops, P.FourByThree, Wr), _defineProperty(_crops, P.NineBySixteen, Vr), _defineProperty(_crops, P.SixteenByNine, Nr), _defineProperty(_crops, P.FacebookPost, Xr), _defineProperty(_crops, P.FacebookProfile, $r), _defineProperty(_crops, P.FacebookTitle, Gr), _defineProperty(_crops, P.InstagramLandscape, jr), _defineProperty(_crops, P.InstagramPortrait, Zr), _defineProperty(_crops, P.InstagramSquare, Yr), _defineProperty(_crops, P.InstagramStory, Jr), _defineProperty(_crops, P.TwitterPost, qr), _defineProperty(_crops, P.TwitterProfile, Qr), _defineProperty(_crops, P.TwitterTitle, _r), _crops),
  dots: tn,
  duplicate: on,
  edit: rn,
  bringToFront: Pr,
  delete: Rr,
  flipHorizontal: nn,
  flipVertical: sn,
  rotate: an
},
    td = (_td = {}, _defineProperty(_td, $.BRIGHTNESS, rr), _defineProperty(_td, $.CONTRAST, ir), _defineProperty(_td, $.SATURATION, pr), _defineProperty(_td, $.CLARITY, nr), _defineProperty(_td, $.SHADOWS, cr), _defineProperty(_td, $.HIGHLIGHTS, lr), _defineProperty(_td, $.EXPOSURE, sr), _defineProperty(_td, $.GAMMA, ar), _defineProperty(_td, $.BLACKS, er), _defineProperty(_td, $.WHITES, hr), _defineProperty(_td, $.TEMPERATURE, dr), _defineProperty(_td, $.SHARPNESS, mr), _td);
import Wo from "react";
import Us from "styled-components";

var ln = c.Button.TextSecondary,
    pn = Us.span(_templateObject56(), function (t) {
  return t.theme.canvasActionBar.foreground;
}),
    Ks = function Ks(_ref30) {
  var t = _ref30.scale,
      o = _ref30.active;
  var e = t.canZoomIn,
      r = t.canZoomOut,
      n = t.zoomLevel;
  return [I.TRANSFORM, I.BRUSH, I.FOCUS, I.STICKER, I.TEXT, I.TEXT_DESIGN].indexOf(o.tool) !== -1 ? null : Wo.createElement(c.Bar.ButtonGroup, null, Wo.createElement(ln, {
    ariaLabel: "Zoom out",
    isDisabled: !r,
    onClick: t.out
  }, "-"), Wo.createElement(pn, null, n, " %"), Wo.createElement(ln, {
    ariaLabel: "Zoom in",
    isDisabled: !e,
    onClick: t.in
  }, "+"));
},
    cn = g("scale", "active")(d(Ks));

pn.defaultProps = {
  theme: Bt
};

var mn = Xs(c.Bar.ButtonGroup)(_templateObject57()),
    $s = function $s(_ref31) {
  var t = _ref31.config,
      o = _ref31.editor,
      e = _ref31.history,
      r = _ref31.custom;

  var n = t.locale.mainCanvasActions,
      i = e.canUndo,
      l = e.canRedo,
      s = t.config.mainCanvasActions,
      p = function p() {
    o.export();
  },
      a = function a() {
    if (o.activeStore.tool === I.TRANSFORM) return null;
    var v = r.getButton("mainCanvasActionUndo");
    return G.createElement(v, {
      key: "mainCanvasActionUndo",
      onClick: e.undo,
      isDisabled: !i,
      label: n.buttonUndo,
      ariaLabel: n.buttonUndo,
      icon: G.createElement(uo.undo, null)
    });
  },
      h = function h() {
    if (o.activeStore.tool === I.TRANSFORM) return null;
    var v = r.getButton("mainCanvasActionRedo");
    return G.createElement(v, {
      key: "mainCanvasActionRedo",
      onClick: e.redo,
      isDisabled: !l,
      label: n.buttonRedo,
      ariaLabel: n.buttonRedo,
      icon: G.createElement(uo.redo, null)
    });
  },
      m = function m() {
    var v = r.getButton("mainCanvasActionExport");
    return G.createElement(v, {
      key: "mainCanvasActionExport",
      onClick: p,
      label: n.buttonExport,
      ariaLabel: n.buttonExport,
      icon: G.createElement(uo.export, null)
    });
  },
      u = function u() {
    if (!t.displayCloseButton) return null;
    var v = r.getButton("mainCanvasActionClose");
    return G.createElement(v, {
      key: "mainCanvasActionClose",
      "data-test": b.MainBarButtonClose,
      onClick: o.close,
      label: n.buttonClose,
      ariaLabel: n.buttonClose,
      icon: G.createElement(uo.close, null)
    });
  },
      S = s.map(function (v) {
    switch (v) {
      case D.UNDO:
        return a;

      case D.REDO:
        return h;

      case D.EXPORT:
        return m;

      case D.CLOSE:
        return u;

      default:
        return null;
    }
  });

  return G.createElement(c.Bar.Index, null, G.createElement(mn, null, S[0] && S[0]() || null, S[1] && S[1]() || null), t.config.enableZoom ? G.createElement(cn, null) : null, G.createElement(mn, null, S[2] && S[2]() || null, S[3] && S[3]() || null));
},
    Gs = g("config", "editor", "history", "custom")(d($s));

import hn from "react";
import Vo from "react";
import js from "styled-components";

var Zs = js.div(_templateObject58()),
    _t =
/*#__PURE__*/
function (_Vo$Component) {
  _inherits(_t, _Vo$Component);

  function _t(o) {
    var _this2;

    _classCallCheck(this, _t);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(_t).call(this, o));

    _this2.onClick = function (o) {
      return function (e) {
        var _this2$props = _this2.props,
            r = _this2$props.onAddSnapshot,
            n = _this2$props.config,
            i = _this2$props.onChange,
            l = _this2$props.colorPickerDirection,
            s = _this2$props.rect,
            _this2$state = _this2.state,
            p = _this2$state.activeIdentifier,
            a = _this2$state.showColorPicker,
            h = _this2$state.colorList,
            m = h.find(function (u) {
          return u.identifier === o;
        });

        if (p === m.identifier && !a) {
          _this2.UIComponent || import("./ui/colorPicker/index.js").then(function (_ref32) {
            var po = _ref32.ColorPicker;
            _this2.UIComponent = po, _this2.forceUpdate();
          });

          var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
              u = _e$currentTarget$getB.left,
              S = _e$currentTarget$getB.width,
              v = _e$currentTarget$getB.top,
              y = _e$currentTarget$getB.height,
              _e$currentTarget$pare = e.currentTarget.parentElement.getBoundingClientRect(),
              L = _e$currentTarget$pare.left,
              A = _e$currentTarget$pare.top,
              H = n.measurements.color.colorPicker,
              F = H.arrow.width / 2,
              V = u - L + S / 2 - 2,
              R = l === "bottom" ? v - A + y + F : v - A - F,
              lo = -24,
              ko = H.width - H.arrow.width - 12;

          V > ko && (lo += V - ko, V -= lo);
          var yo = !0;

          if (l === "bottom" && s) {
            var po = s.height,
                Yo = s.top,
                co = v - Yo,
                So = po - (co + y),
                Do = n.measurements.color.colorPicker.height + F;
            So < Do && (R = So - Do), co + R < co + y / 2 && (R += F, yo = !1);
          }

          _this2.setState({
            showColorPicker: !0,
            showColorPickerArrow: yo,
            arrowOffset: V,
            topOffset: R,
            leftOffset: lo
          });
        } else a ? _this2.setState({
          showColorPicker: !1
        }) : (i(m.color), _this2.setState({
          activeIdentifier: o
        }), r && r());
      };
    };

    _this2.onChange = function (_ref33) {
      var o = _ref33.color,
          e = _ref33.colorString;
      var r = _this2.props.onChange,
          _this2$state2 = _this2.state,
          n = _this2$state2.activeIdentifier,
          i = _this2$state2.colorList,
          l = i.findIndex(function (s) {
        return s.identifier === n;
      });

      if (l !== -1) {
        var s = _toConsumableArray(i);

        s[l] = {
          identifier: i[l].identifier,
          colorString: e,
          color: o
        }, _this2.setState({
          colorList: s
        });
      }

      r(o);
    };

    _this2.onChangeColorPicker = function (_ref34) {
      var o = _ref34.color,
          e = _ref34.colorString;

      _this2.onChange({
        color: [o[0] / 255, o[1] / 255, o[2] / 255, o[3]],
        colorString: e
      });
    };

    _this2.closeColorPicker = function () {
      _this2.setState({
        showColorPicker: !1
      });
    };

    _this2.getColorPicker = function () {
      var _this2$props2 = _this2.props,
          o = _this2$props2.activeColor,
          e = _this2$props2.labelsColor,
          r = _this2$props2.colorPickerDirection,
          n = _this2$props2.onAddSnapshot,
          _this2$state3 = _this2.state,
          i = _this2$state3.showColorPicker,
          l = _this2$state3.showColorPickerArrow,
          s = _this2$state3.arrowOffset,
          p = _this2$state3.leftOffset,
          a = _this2$state3.topOffset;
      if (!_this2.UIComponent) return null;
      var h = _this2.UIComponent;
      return Vo.createElement(h, {
        color: dn(o),
        show: i,
        showArrow: l,
        direction: r,
        arrowOffset: s,
        leftOffset: p,
        topOffset: a,
        labelHex: e.hex,
        labelR: e.r,
        labelG: e.g,
        labelB: e.b,
        labelSliderOpacity: e.sliderOpacity,
        labelSliderHue: e.sliderHue,
        onChange: _this2.onChangeColorPicker,
        onRequestClose: _this2.closeColorPicker,
        onAddSnapshot: n
      });
    };

    var e = _this2.props.colors;
    _this2.state = {
      activeIdentifier: "",
      activeSprite: "",
      colorList: _toConsumableArray(e),
      showColorPicker: !1,
      showColorPickerArrow: !1,
      arrowOffset: 0,
      leftOffset: 0,
      topOffset: 0
    }, _this2.UIComponent = null;
    return _this2;
  }

  _createClass(_t, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          o = _this$props.isDisabled,
          e = _this$props.custom,
          r = _this$props.config,
          _this$state = this.state,
          n = _this$state.activeIdentifier,
          i = _this$state.colorList,
          l = e.getColorItem(),
          s = r.assetProvider.getPath("controls", "/tiled-background.png"),
          p = i.map(function (a) {
        return Vo.createElement(l, {
          key: "".concat(a.colorString, "-item-").concat(a.identifier),
          isActive: a.identifier === n,
          isDisabled: o,
          onClick: _this3.onClick(a.identifier),
          color: a.colorString,
          label: a.identifier,
          tiledBackgroundUrl: s
        });
      });
      return Vo.createElement(Zs, {
        "data-test": b.ColorList
      }, p, this.getColorPicker());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref35, _ref36) {
      var o = _ref35.activeSprite,
          e = _ref35.activeColor;
      var r = _ref36.activeSprite,
          n = _ref36.colorList;

      if (o !== r || !o) {
        var i = ee(dn(e)),
            l = n.find(function (_ref37) {
          var s = _ref37.colorString;
          return s === i;
        });
        return {
          activeSprite: o,
          activeIdentifier: l ? l.identifier : ""
        };
      }

      return null;
    }
  }]);

  return _t;
}(Vo.Component);

_t.defaultProps = {
  colorPickerDirection: "bottom",
  isDisabled: !1
}, _t = $t([g("config", "custom"), d], _t);

var Js = function Js(t) {
  return hn.createElement(Ys.Consumer, null, function (_ref38) {
    var o = _ref38.rect;
    return hn.createElement(_t, x(x({}, t), {
      rect: o
    }));
  });
};

import so, { useRef as Ya, useEffect as Ja } from "react";
import { useContext as qs } from "react";

function j() {
  return qs(Qs);
}

import Zt, { useRef as Ea } from "react";
import No from "react";
import fn from "styled-components";

var _s = fn(c.Controls.Container)(_templateObject59()),
    Rs = fn.div(_templateObject60()),
    un =
/*#__PURE__*/
function (_No$Component) {
  _inherits(un, _No$Component);

  function un(o) {
    var _this4;

    _classCallCheck(this, un);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(un).call(this, o));
    _this4.INITIAL_POSITION = {
      x: void 0,
      y: void 0
    };
    _this4.state = x(x({}, _this4.INITIAL_POSITION), {
      isDrawing: !1
    });
    _this4.containerElementRef = null;

    _this4.getCursorCoordinates = function (o) {
      var e = 0,
          r = 0;

      if (o.type.indexOf("touch") !== -1) {
        var s = o;
        if (!s.touches.length) return x(x({}, _this4.INITIAL_POSITION), {
          height: 0,
          width: 0
        });
        e = s.touches[0].clientX, r = s.touches[0].clientY;
      } else {
        var _s2 = o;
        e = _s2.clientX, r = _s2.clientY;
      }

      var n = _this4.containerElementRef.current.getBoundingClientRect(),
          i = e - n.left,
          l = r - n.top;

      return {
        x: i,
        y: l,
        height: n.height,
        width: n.width
      };
    };

    _this4.draw = function (o) {
      o.preventDefault(), o.stopPropagation(), _this4.touchDraw(o);
    };

    _this4.touchDraw = function (o) {
      var _this4$getCursorCoord = _this4.getCursorCoordinates(o),
          e = _this4$getCursorCoord.x,
          r = _this4$getCursorCoord.y;

      e !== void 0 && r !== void 0 && (_this4.setState({
        x: e,
        y: r
      }), _this4.state.isDrawing && _this4.brushTool.strokePosition({
        x: e,
        y: r
      }));
    };

    _this4.start = function () {
      _this4.brushTool.clickableCanvas(!1), _this4.setState({
        isDrawing: !0
      }), _this4.brushTool.beginStroke();
    };

    _this4.stop = function (o) {
      _this4.state.isDrawing && (o.preventDefault(), o.stopPropagation(), _this4.setState({
        isDrawing: !1
      }), _this4.brushTool.endStroke(), _this4.brushTool.clickableCanvas(!0));
    };

    _this4.setInitialPosition = function () {
      _this4.setState(x({}, _this4.INITIAL_POSITION));
    };

    _this4.mouseOut = function (o) {
      var e = _this4.props.config;
      o.preventDefault(), o.stopPropagation();

      var r = _this4.brushTool.sizeOnScreenSpace / 2,
          _this4$getCursorCoord2 = _this4.getCursorCoordinates(o),
          n = _this4$getCursorCoord2.x,
          i = _this4$getCursorCoord2.y,
          l = _this4$getCursorCoord2.height,
          s = _this4$getCursorCoord2.width;

      n && i && (n < 0 || i < 0 || n > s - r || i > l - r || i < e.measurements.mainCanvasActionBar.height) && _this4.setInitialPosition();
    };

    _this4.touchEnd = function (o) {
      o.preventDefault(), o.stopPropagation();
      var _this4$state = _this4.state,
          e = _this4$state.x,
          r = _this4$state.y;
      e && r && _this4.setInitialPosition();
    };

    _this4.getCursor = function () {
      var _this4$state2 = _this4.state,
          o = _this4$state2.x,
          e = _this4$state2.y;

      if (o && e) {
        var r = ee(_this4.brushTool.color),
            n = "".concat(_this4.brushTool.sizeOnScreenSpace, "px"),
            i = {
          left: "".concat(_this4.state.x, "px"),
          top: "".concat(_this4.state.y, "px"),
          borderColor: r,
          height: n,
          width: n
        };
        return No.createElement(Rs, {
          style: i,
          "data-test": b.Cursor
        });
      }

      return null;
    };

    _this4.containerElementRef = No.createRef();
    return _this4;
  }

  _createClass(un, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mouseup", this.stop, !1), document.addEventListener("touchend", this.stop, {
        passive: !1
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mouseup", this.stop, !1), document.removeEventListener("touchend", this.stop, !1);
    }
  }, {
    key: "render",
    value: function render() {
      return No.createElement(_s, {
        ref: this.containerElementRef,
        "data-test": b.CursorContainer,
        onMouseMove: this.draw,
        onTouchMove: this.touchDraw,
        onMouseDown: this.start,
        onTouchStart: this.start,
        onMouseOut: this.mouseOut,
        onTouchEnd: this.touchEnd
      }, this.getCursor());
    }
  }, {
    key: "brushTool",
    get: function get() {
      return this.props.brushTool;
    }
  }]);

  return un;
}(No.Component),
    gn = g("brushTool", "config")(d(un));

import ea from "react";
import it from "react";
import ta from "styled-components";

var Z = function Z(t, o) {
  return t !== void 0 && o !== void 0 && !Number.isNaN(t) && !Number.isNaN(o);
};

var re = ta(c.Controls.Knob)(_templateObject61(), function (t) {
  return t.theme.measurements.canvasControls.knob.touchable.desktop / 2;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.touchable.desktop / 2;
}),
    oa = c.Controls.Container,
    vn =
/*#__PURE__*/
function (_it$Component) {
  _inherits(vn, _it$Component);

  function vn() {
    var _this5;

    _classCallCheck(this, vn);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(vn).apply(this, arguments));

    _this5.start = function (o, _ref39) {
      var e = _ref39.x,
          r = _ref39.y;
      Z(e, r) && _this5.focusTool.setStart({
        x: e,
        y: r
      });
    };

    _this5.end = function (o, _ref40) {
      var e = _ref40.x,
          r = _ref40.y;
      Z(e, r) && _this5.focusTool.setEnd({
        x: e,
        y: r
      });
    };

    _this5.onKnob1DragStart = function (o, e) {
      _this5.focusTool.clickableCanvas(!1), _this5.start(o, e);
    };

    _this5.onKnob1DragStop = function (o, e) {
      _this5.addSnapshot(e, _this5.historyLocale.focusPosition), _this5.start(o, e), _this5.focusTool.clickableCanvas(!0);
    };

    _this5.onKnob2DragStart = function (o, e) {
      _this5.focusTool.clickableCanvas(!1), _this5.end(o, e);
    };

    _this5.onKnob2DragStop = function (o, e) {
      _this5.addSnapshot(e, _this5.historyLocale.focusPosition), _this5.end(o, e), _this5.focusTool.clickableCanvas(!0);
    };

    _this5.addSnapshot = function (_ref41, r) {
      var o = _ref41.x,
          e = _ref41.y;
      Z(o, e) && _this5.focusTool.toolSnapshot(r);
    };

    _this5.getLine = function () {
      var _this5$props$canvas$c = _this5.props.canvas.canvasSize,
          o = _this5$props$canvas$c.height,
          e = _this5$props$canvas$c.width,
          r = _this5.focusTool.startOnPreview,
          n = _this5.focusTool.endOnPreview;
      return it.createElement("svg", {
        focusable: "false",
        height: o,
        width: e
      }, it.createElement("line", {
        x1: r.x,
        y1: r.y,
        x2: n.x,
        y2: n.y,
        strokeWidth: "2",
        stroke: "currentColor"
      }));
    };

    return _this5;
  }

  _createClass(vn, [{
    key: "render",
    value: function render() {
      return it.createElement(oa, null, it.createElement(c.Controls.Line, null, this.getLine()), it.createElement(k.Draggable, {
        bounds: "parent",
        position: this.focusTool.startOnPreview,
        onStart: this.onKnob1DragStart,
        onDrag: this.start,
        onStop: this.onKnob1DragStop
      }, it.createElement(re, null)), it.createElement(k.Draggable, {
        bounds: "parent",
        onStart: this.onKnob2DragStart,
        onDrag: this.end,
        onStop: this.onKnob2DragStop,
        position: this.focusTool.endOnPreview
      }, it.createElement(re, null)));
    }
  }, {
    key: "focusTool",
    get: function get() {
      return this.props.focusTool;
    }
  }, {
    key: "historyLocale",
    get: function get() {
      return this.focusTool.locale.history;
    }
  }]);

  return vn;
}(it.Component);

re.defaultProps = {
  theme: Bt
};
var bn = g("canvas", "focusTool")(d(vn));
import Rt from "react";

var go =
/*#__PURE__*/
function (_Rt$Component) {
  _inherits(go, _Rt$Component);

  function go() {
    var _this6;

    _classCallCheck(this, go);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(go).apply(this, arguments));

    _this6.getKnobPosition = function () {
      var o = _this6.props.focusTool,
          e = o.origin,
          r = o.size,
          n = r / 2,
          i = Math.PI / 2 + o.rotation;
      return {
        x: e.x + n * Math.cos(i),
        y: e.y + n * Math.sin(i)
      };
    };

    _this6.onArea = function (o, _ref42) {
      var e = _ref42.x,
          r = _ref42.y;
      var n = _this6.props.editor,
          i = n.configStore.measurements.canvasControls.knob.size;

      if (Z(e, r)) {
        var _this6$props = _this6.props,
            l = _this6$props.canvas,
            s = _this6$props.focusTool,
            p = s.size,
            a = s.mirroredAreaWidth,
            h = e + a / 2,
            m = r + p / 2,
            u = new f(_this6.getKnobPosition()),
            v = new f({
          x: e,
          y: r
        }).subtract(new f(_this6.areaPosition)),
            y = u.add(v);
        y.x > i && y.x < l.canvasSize.width - i && y.y > i && y.y < l.canvasSize.height - i && s.setOrigin({
          x: h,
          y: m
        });
      }
    };

    _this6.onKnob = function (o, _ref43) {
      var e = _ref43.x,
          r = _ref43.y;
      var n = _this6.props.focusTool;

      if (Z(e, r)) {
        n.clickableCanvas(!1);
        var i = new f(n.origin),
            l = new f(e, r),
            s = i.subtract(l),
            p = s.magnitude,
            a = Math.PI / 2 + Math.atan2(s.y, s.x);
        n.setSize(p * 2), n.setRotation(a);
      }
    };

    _this6.onAreaDragStop = function (o, e) {
      var r = _this6.props.focusTool;
      _this6.addSnapshot(e, r.locale.history.focusPosition), _this6.onArea(o, e), r.clickableCanvas(!0);
    };

    _this6.onKnobDragStop = function (o, e) {
      var r = _this6.props.focusTool;
      _this6.addSnapshot(e, r.locale.history.focusSize), _this6.onKnob(o, e), r.clickableCanvas(!0);
    };

    _this6.addSnapshot = function (_ref44, r) {
      var o = _ref44.x,
          e = _ref44.y;
      var n = _this6.props.focusTool;
      Z(o, e) && n.toolSnapshot(r);
    };

    return _this6;
  }

  _createClass(go, [{
    key: "render",
    value: function render() {
      var _this$areaPosition = this.areaPosition,
          o = _this$areaPosition.x,
          e = _this$areaPosition.y,
          r = this.props.focusTool;
      return Rt.createElement(c.Controls.Container, null, Rt.createElement(k.Draggable, {
        bounds: "parent",
        onStart: this.onKnob,
        onDrag: this.onKnob,
        onStop: this.onKnobDragStop,
        position: this.getKnobPosition()
      }, Rt.createElement(c.Controls.Knob, null)), Rt.createElement(k.Draggable, {
        onStart: this.onArea,
        onDrag: this.onArea,
        onStop: this.onAreaDragStop,
        position: {
          x: o,
          y: e
        },
        rotation: r.rotation
      }, Rt.createElement(c.Controls.Area, {
        "data-test": b.Focus,
        height: r.size,
        width: r.mirroredAreaWidth
      })));
    }
  }, {
    key: "areaPosition",
    get: function get() {
      var o = this.props.focusTool,
          e = o.origin,
          r = o.size,
          n = o.mirroredAreaWidth;
      return {
        x: e.x - n / 2,
        y: e.y - r / 2
      };
    }
  }]);

  return go;
}(Rt.Component);

go = $t([g("focusTool", "canvas", "editor"), d], go);
import to from "react";

var vo =
/*#__PURE__*/
function (_to$Component) {
  _inherits(vo, _to$Component);

  function vo() {
    var _this7;

    _classCallCheck(this, vo);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(vo).apply(this, arguments));
    _this7.state = {
      knobAngle: 2.35
    };

    _this7.onCircle = function (o, _ref45) {
      var e = _ref45.x,
          r = _ref45.y;

      if (Z(e, r)) {
        var n = _this7.props.focusTool;
        n.setCenter({
          x: e + n.radius,
          y: r + n.radius
        });
      }
    };

    _this7.onKnob = function (o, _ref46) {
      var e = _ref46.x,
          r = _ref46.y;

      if (Z(e, r)) {
        var n = _this7.props.focusTool,
            i = new f(e, r),
            s = new f(n.center.x, n.center.y).subtract(i),
            p = s.magnitude,
            a = -Math.atan2(s.y, s.x);
        _this7.setState({
          knobAngle: a
        }), n.setRadius(p);
      }
    };

    _this7.onCircleDragStart = function (o, e) {
      var r = _this7.props.focusTool;
      r.clickableCanvas(!1), _this7.onCircle(o, e);
    };

    _this7.onCircleDragStop = function (o, e) {
      var r = _this7.props.focusTool;
      _this7.addSnapshot(e, r.locale.history.focusPosition), _this7.onCircle(o, e), r.clickableCanvas(!0);
    };

    _this7.onKnobDragStart = function (o, e) {
      var r = _this7.props.focusTool;
      r.clickableCanvas(!1), _this7.onKnob(o, e);
    };

    _this7.onKnobDragStop = function (o, e) {
      var r = _this7.props.focusTool;
      _this7.addSnapshot(e, r.locale.history.focusSize), _this7.onKnob(o, e), r.clickableCanvas(!0);
    };

    _this7.addSnapshot = function (_ref47, r) {
      var o = _ref47.x,
          e = _ref47.y;
      var n = _this7.props.focusTool;
      Z(o, e) && n.toolSnapshot(r);
    };

    return _this7;
  }

  _createClass(vo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        knobAngle: 2.35
      });
    }
  }, {
    key: "render",
    value: function render() {
      var o = this.props.focusTool,
          e = this.state.knobAngle,
          r = o.center,
          n = o.radius,
          i = {
        x: r.x - n,
        y: r.y - n
      },
          l = Math.PI - e,
          s = {
        x: r.x + n * Math.cos(l),
        y: r.y + n * Math.sin(l)
      };
      return to.createElement(c.Controls.Container, null, to.createElement(k.Draggable, {
        bounds: "parent",
        onStart: this.onKnobDragStart,
        onDrag: this.onKnob,
        onStop: this.onKnobDragStop,
        position: s
      }, to.createElement(c.Controls.Knob, null)), to.createElement(k.Draggable, {
        onStart: this.onCircleDragStart,
        onDrag: this.onCircle,
        onStop: this.onCircleDragStop,
        position: i
      }, to.createElement(c.Controls.Circle, {
        "data-test": b.Focus,
        radius: n
      })));
    }
  }]);

  return vo;
}(to.Component);

vo = $t([g("focusTool", "canvas"), d], vo);
var xn = d(function () {
  var _j = j(),
      t = _j.focusTool,
      o = t.state,
      r = function () {
    switch (o.identifier) {
      case ne.LINEAR:
        return bn;

      case ne.RADIAL:
        return vo;

      case ne.MIRRORED:
        return go;

      default:
        return null;
    }
  }();

  return t.isOptionSelected && r ? ea.createElement(r, null) : null;
});
import st from "react";
import ro from "react";
import oo from "react";

var ra = function ra(_ref48) {
  var _s3;

  var t = _ref48.stickerTool,
      o = _ref48.custom;

  var e = t.locale.canvasActions,
      r = function r(a) {
    a.stopPropagation(), t.delete();
  },
      n = function n(a) {
    a.stopPropagation(), t.bringToFront();
  },
      i = function i(a) {
    a.stopPropagation(), t.flipHorizontally();
  },
      l = function l(_ref49) {
    var a = _ref49.key,
        h = _ref49.customButtonKey,
        m = _ref49.onClick,
        u = _ref49.label,
        S = _ref49.icon;
    var v = o.getButton(h);
    return oo.createElement(v, {
      key: a,
      onClick: m,
      label: u,
      ariaLabel: u,
      icon: S
    });
  },
      s = (_s3 = {}, _defineProperty(_s3, D.BRING_TO_FRONT, {
    key: D.BRING_TO_FRONT,
    customButtonKey: "canvasActionBringToFront",
    onClick: n,
    label: e.buttonBringToFront,
    icon: oo.createElement(M.bringToFront, null)
  }), _defineProperty(_s3, D.FLIP, {
    key: D.FLIP,
    customButtonKey: "canvasActionFlip",
    onClick: i,
    label: e.buttonFlipHorizontal,
    icon: oo.createElement(M.flipHorizontal, null)
  }), _defineProperty(_s3, D.DUPLICATE, {
    key: D.DUPLICATE,
    customButtonKey: "canvasActionDuplicate",
    onClick: function onClick() {
      return t.duplicate();
    },
    label: e.buttonDuplicate,
    icon: oo.createElement(M.duplicate, null)
  }), _defineProperty(_s3, D.DELETE, {
    key: D.DELETE,
    customButtonKey: "canvasActionDelete",
    onClick: r,
    label: e.buttonDelete,
    icon: oo.createElement(M.delete, null)
  }), _s3),
      p = t.config.canvasActions.map(function (a) {
    return s[a] ? l(s[a]) : null;
  });

  return t.isStickerSelected ? oo.createElement(c.Bar.ButtonGroup, null, p) : null;
},
    Cn = g("stickerTool", "custom")(d(ra));

import eo from "react";

var na = function na(_ref50) {
  var _s4;

  var t = _ref50.textTool,
      o = _ref50.sprite,
      e = _ref50.custom;

  var r = t.locale.canvasActions,
      n = function n(a) {
    a.stopPropagation(), t.delete();
  },
      i = function i(a) {
    a.stopPropagation(), t.bringToFront();
  },
      l = function l(_ref51) {
    var a = _ref51.key,
        h = _ref51.customButtonKey,
        m = _ref51.onClick,
        u = _ref51.label,
        S = _ref51.icon;
    var v = e.getButton(h);
    return eo.createElement(v, {
      key: a,
      onClick: m,
      label: u,
      ariaLabel: u,
      icon: S
    });
  },
      s = (_s4 = {}, _defineProperty(_s4, D.EDIT, {
    key: D.EDIT,
    customButtonKey: "canvasActionEdit",
    onClick: function onClick() {
      return t.setEditMode(!0);
    },
    label: r.buttonEdit,
    icon: eo.createElement(M.edit, null)
  }), _defineProperty(_s4, D.BRING_TO_FRONT, {
    key: D.BRING_TO_FRONT,
    customButtonKey: "canvasActionBringToFront",
    onClick: i,
    label: r.buttonBringToFront,
    icon: eo.createElement(M.bringToFront, null)
  }), _defineProperty(_s4, D.DUPLICATE, {
    key: D.DUPLICATE,
    customButtonKey: "canvasActionDuplicate",
    onClick: function onClick() {
      return t.duplicate();
    },
    label: r.buttonDuplicate,
    icon: eo.createElement(M.duplicate, null)
  }), _defineProperty(_s4, D.DELETE, {
    key: D.DELETE,
    customButtonKey: "canvasActionDelete",
    onClick: n,
    label: r.buttonDelete,
    icon: eo.createElement(M.delete, null)
  }), _s4),
      p = t.config.canvasActions.map(function (a) {
    return s[a] ? l(s[a]) : null;
  });

  return o.isSpriteText ? eo.createElement(c.Bar.ButtonGroup, null, p) : null;
},
    wn = g("textTool", "sprite", "custom")(d(na));

import Gt from "react";

var ia = function ia(_ref52) {
  var _s5;

  var t = _ref52.textDesignTool,
      o = _ref52.custom;

  var e = t.locale.canvasActions,
      r = function r(a) {
    a.stopPropagation(), t.delete();
  },
      n = function n(a) {
    a.stopPropagation(), t.bringToFront();
  },
      i = function i(a) {
    a.stopPropagation(), t.invertBackground();
  },
      l = function l(_ref53) {
    var a = _ref53.key,
        h = _ref53.customButtonKey,
        m = _ref53.onClick,
        u = _ref53.label,
        S = _ref53.icon;
    var v = o.getButton(h);
    return Gt.createElement(v, {
      key: a,
      onClick: m,
      label: u,
      ariaLabel: u,
      icon: S
    });
  },
      s = (_s5 = {}, _defineProperty(_s5, D.EDIT, {
    key: D.EDIT,
    customButtonKey: "canvasActionEdit",
    onClick: function onClick() {
      return t.setEditMode(!0);
    },
    label: e.buttonEdit,
    icon: Gt.createElement(M.edit, null)
  }), _defineProperty(_s5, D.BRING_TO_FRONT, {
    key: D.BRING_TO_FRONT,
    customButtonKey: "canvasActionBringToFront",
    onClick: n,
    label: e.buttonBringToFront,
    icon: Gt.createElement(M.bringToFront, null)
  }), _defineProperty(_s5, D.INVERT, {
    key: D.INVERT,
    customButtonKey: "canvasActionInvert",
    onClick: i,
    label: e.buttonInvert,
    icon: Gt.createElement(M.flipHorizontal, null)
  }), _defineProperty(_s5, D.DUPLICATE, {
    key: D.DUPLICATE,
    customButtonKey: "canvasActionDuplicate",
    onClick: function onClick() {
      return t.duplicate();
    },
    label: e.buttonDuplicate,
    icon: Gt.createElement(M.duplicate, null)
  }), _defineProperty(_s5, D.DELETE, {
    key: D.DELETE,
    customButtonKey: "canvasActionDelete",
    onClick: r,
    label: e.buttonDelete,
    icon: Gt.createElement(M.delete, null)
  }), _s5),
      p = t.config.canvasActions.map(function (a) {
    return s[a] ? l(s[a]) : null;
  });

  return t.isTextDesignSelected ? Gt.createElement(c.Bar.ButtonGroup, null, p) : null;
},
    kn = g("textDesignTool", "custom")(d(ia));

var bo =
/*#__PURE__*/
function (_ro$Component) {
  _inherits(bo, _ro$Component);

  function bo(o) {
    var _this8;

    _classCallCheck(this, bo);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(bo).call(this, o));
    _this8.actionsRef = null;

    _this8.spriteControlPosition = function () {
      var _this8$props = _this8.props,
          o = _this8$props.config,
          e = _this8$props.sprite,
          r = _this8$props.canvas.canvasSize,
          _o$measurements$canva = o.measurements.canvasControls.sprite,
          n = _o$measurements$canva.controlPadding,
          i = _o$measurements$canva.controlOffset,
          _e$position = e.position,
          l = _e$position.x,
          s = _e$position.y,
          _e$currentSprite$size = e.currentSprite.size,
          p = _e$currentSprite$size.height,
          a = _e$currentSprite$size.width,
          h = e.rotationWRTOutputRotation,
          m = _this8.actionsRef.current,
          u = new f(0, 0);

      if (m) {
        var y = m.getBoundingClientRect();
        u = new f(y.width / 2 + i, y.height + i);
      }

      var S = Math.abs(a * Math.sin(h)) + Math.abs(p * Math.cos(h)),
          v = new f(l, s - S / 2 - n - i).clamp(u, new f(r.width, r.height).subtract(u));
      return {
        left: v.x,
        top: v.y
      };
    };

    _this8.getSpriteControls = function () {
      var o = _this8.props.sprite;

      switch (o.tool) {
        case I.TEXT:
          return ro.createElement(wn, null);

        case I.TEXT_DESIGN:
          return ro.createElement(kn, null);

        case I.STICKER:
          return ro.createElement(Cn, null);

        default:
          return null;
      }
    };

    _this8.actionsRef = ro.createRef(), _this8.state = {
      isMounted: !1
    };
    return _this8;
  }

  _createClass(bo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var o = this.props.sprite,
          e = this.state.isMounted,
          r = !o.isDragMode && !o.isEditMode,
          n = this.spriteControlPosition();
      return ro.createElement(c.Controls.SpriteActionsWrapper, {
        "data-test": b.SpriteActions,
        ref: this.actionsRef,
        show: r && e,
        style: x({}, n)
      }, this.getSpriteControls());
    }
  }]);

  return bo;
}(ro.Component);

bo = $t([g("sprite", "config", "editor", "canvas"), d], bo);
import _ from "react";
var Uo = c.Controls.Corner,
    Ko = k.Draggable,
    ie = new f(0, 0),
    se = new f(0, 0),
    yn = d(function () {
  var _j2 = j(),
      t = _j2.config,
      o = _j2.sprite,
      e = o.leftTopPosition,
      r = o.leftBottomPosition,
      n = o.rightTopPosition,
      i = o.rightBottomPosition,
      l = t.measurements.canvasControls.corner.borderWidth,
      s = function s(_ref54) {
    var m = _ref54.clientX,
        u = _ref54.clientY;
    m !== void 0 && u !== void 0 && o.onCornerDrag(se.subtract(ie.subtract(new f(m, u))));
  },
      p = function p(m) {
    switch (m) {
      case "leftTop":
        return e;

      case "leftBottom":
        return r;

      case "rightTop":
        return n;

      case "rightBottom":
        return i;

      default:
        return e;
    }
  },
      a = function a(m, u) {
    var S = m.clientX,
        v = m.clientY;
    ie = new f(S, v), se = new f(p(u)), o.clickableCanvas(!1), o.setDragMode(!0);
  },
      h = function h() {
    o.clickableCanvas(!0), o.setDragMode(!1), o.spriteSnapshot("size"), ie = new f(0, 0), se = new f(0, 0);
  };

  return _.createElement(_.Fragment, null, _.createElement(Ko, {
    onStop: h,
    onDrag: s,
    onStart: function onStart(m) {
      return a(m, "leftTop");
    }
  }, _.createElement(Uo, {
    "data-test": b.SpriteTopLeft,
    vertical: "top",
    horizontal: "left",
    borderWidth: l
  })), _.createElement(Ko, {
    onStop: h,
    onDrag: s,
    onStart: function onStart(m) {
      return a(m, "leftBottom");
    }
  }, _.createElement(Uo, {
    "data-test": b.SpriteBottomLeft,
    vertical: "bottom",
    horizontal: "left",
    borderWidth: l
  })), _.createElement(Ko, {
    onStop: h,
    onDrag: s,
    onStart: function onStart(m) {
      return a(m, "rightTop");
    }
  }, _.createElement(Uo, {
    "data-test": b.SpriteTopRight,
    vertical: "top",
    horizontal: "right",
    borderWidth: l
  })), _.createElement(Ko, {
    onStop: h,
    onDrag: s,
    onStart: function onStart(m) {
      return a(m, "rightBottom");
    }
  }, _.createElement(Uo, {
    "data-test": b.SpriteBottomRight,
    vertical: "bottom",
    horizontal: "right",
    borderWidth: l
  })));
});
import no from "react";
import Sn from "styled-components";

var sa = Sn.img(_templateObject62()),
    aa = Sn.img(_templateObject63()),
    le = new f(0, 0),
    pe = new f(0, 0),
    la = function la(_ref55) {
  var t = _ref55.sprite,
      o = _ref55.config;

  var e = t.leftMidPosition,
      r = t.rightMidPosition,
      n = o.assetProvider.getPath("controls", "/arrow-left.png"),
      i = o.assetProvider.getPath("controls", "/arrow-right.png"),
      l = function l(a, h) {
    t.setDragMode(!0), t.clickableCanvas(!1);
    var m = a.clientX,
        u = a.clientY;
    le = new f(m, u), pe = new f(h === "left" ? e : r);
  },
      s = function s() {
    t.clickableCanvas(!0), t.setDragMode(!1), t.addSnapshot(ae.EDIT, t.textDesignLocale.padding), le = new f(0, 0), pe = new f(0, 0);
  },
      p = function p(_ref56) {
    var a = _ref56.clientX,
        h = _ref56.clientY;

    if (a !== void 0 && h !== void 0) {
      var m = pe.subtract(le.subtract(new f(a, h)));
      t.onPaddingDrag(m);
    }
  };

  return no.createElement(no.Fragment, null, no.createElement(k.Draggable, {
    onStart: function onStart(a) {
      return l(a, "left");
    },
    onDrag: p,
    onStop: s
  }, no.createElement(sa, {
    src: n
  })), no.createElement(k.Draggable, {
    onStart: function onStart(a) {
      return l(a, "right");
    },
    onDrag: p,
    onStop: s
  }, no.createElement(aa, {
    src: i
  })));
},
    Dn = g("sprite", "config")(d(la));

import Tn from "react";
import pa from "styled-components";

var Bn = pa(c.Controls.Knob)(_templateObject64(), function (t) {
  return t.url;
}, function (t) {
  return t.theme.measurements.canvasControls.knob.size / 2;
}),
    ce = new f(0, 0),
    me = new f(0, 0),
    ca = function ca(_ref57) {
  var t = _ref57.config,
      o = _ref57.sprite,
      e = _ref57.snapping;

  var r = o.rightBottomHandlePosition,
      n = o.leftBottomHandlePosition,
      i = {
    x: (r.x + n.x) / 2,
    y: (r.y + n.y) / 2
  },
      l = function l(_ref58) {
    var m = _ref58.clientX,
        u = _ref58.clientY;
    ce = new f(m, u), me = new f(i), o.setDragMode(!0), o.clickableCanvas(!1);
  },
      s = function s() {
    o.clickableCanvas(!0), o.setDragMode(!1), o.spriteSnapshot("rotation"), e.hideRotationGuides(), ce = new f(0, 0), me = new f(0, 0);
  },
      p = function p(_ref59) {
    var m = _ref59.clientX,
        u = _ref59.clientY;

    if (m !== void 0 && u !== void 0) {
      var S = me.subtract(ce.subtract(new f(m, u))),
          v = o.position,
          y = new f(v.x, v.y),
          L = S.subtract(y),
          A = Math.atan2(L.y, L.x) - Math.PI / 2,
          H = e.snapToRotation(A, L, o.currentRect);
      o.setRotation(H);
    }
  },
      a = function a(m) {
    p(m);
  },
      h = t.assetProvider.getPath("controls", "/".concat(De() ? "rotate-windows" : "rotate-osx", ".png"));

  return Tn.createElement(k.Draggable, {
    onStart: l,
    onDrag: a,
    onStop: s
  }, Tn.createElement(Bn, {
    url: h
  }));
};

Bn.defaultProps = {
  theme: Bt
};
var Mn = g("sprite", "snapping", "config")(d(ca));
import io from "react";
import de from "styled-components";

var zn = de(c.Controls.Width)(_templateObject65()),
    Ln = de(zn)(_templateObject66(), function (t) {
  return t.theme.measurements.canvasControls.width.size / 2;
}),
    An = de(zn)(_templateObject67(), function (t) {
  return t.theme.measurements.canvasControls.width.size / 2;
}),
    he = new f(0, 0),
    fe = new f(0, 0),
    ma = function ma(_ref60) {
  var t = _ref60.sprite,
      o = _ref60.textTool;

  var e = t.leftMidPadPosition,
      r = t.rightMidPadPosition,
      n = function n(s, p) {
    t.setDragMode(!0), t.clickableCanvas(!1);
    var a = s.clientX,
        h = s.clientY;
    he = new f(a, h), fe = new f(p === "left" ? e : r);
  },
      i = function i() {
    t.clickableCanvas(!0), t.setDragMode(!1), t.addSnapshot(ae.EDIT, t.textLocale.width), o.updateDefaultFontSize(), he = new f(0, 0), fe = new f(0, 0);
  },
      l = function l(_ref61) {
    var s = _ref61.clientX,
        p = _ref61.clientY;

    if (s !== void 0 && p !== void 0) {
      var a = fe.subtract(he.subtract(new f(s, p)));
      t.onWidthDrag(a);
    }
  };

  return io.createElement(io.Fragment, null, io.createElement(k.Draggable, {
    onStart: function onStart(s) {
      return n(s, "left");
    },
    onDrag: l,
    onStop: i
  }, io.createElement(Ln, null)), io.createElement(k.Draggable, {
    onStart: function onStart(s) {
      return n(s, "right");
    },
    onDrag: l,
    onStop: i
  }, io.createElement(An, null)));
};

Ln.defaultProps = {
  theme: Bt
};
An.defaultProps = {
  theme: Bt
};
var Pn = g("sprite", "textTool")(d(ma));
var da = k.Draggable,
    ue = new f(0, 0),
    ge = new f(0, 0),
    In = d(function () {
  var _j3 = j(),
      t = _j3.active,
      o = _j3.config,
      e = _j3.snapping,
      r = _j3.sprite,
      n = function n(_ref62) {
    var L = _ref62.clientX,
        A = _ref62.clientY;

    var H = ge.subtract(ue.subtract(new f(L, A))),
        _e$snapToPosition = e.snapToPosition({
      x: H.x,
      y: H.y
    }, r.currentRect),
        F = _e$snapToPosition.x,
        V = _e$snapToPosition.y;

    r.setPosition({
      x: F,
      y: V
    });
  },
      i = function i(L) {
    var A = L.clientX,
        H = L.clientY;
    ue = new f(A, H), ge = new f(r.position), r.setDragMode(!0), e.updateGuides();
  },
      l = function l() {
    ue = new f(0, 0), ge = new f(0, 0), r.setDragMode(!1), r.spriteSnapshot("position"), e.hidePositionGuides();
  },
      s = function s(L) {
    L.preventDefault(), L.stopPropagation(), r.setEditMode(!0);
  };

  if (!function () {
    var L = t.tool,
        A = r.tool;
    return r.isSpriteSelected && L === A;
  }()) return null;
  var a = r.isSpriteText,
      h = r.isSpriteTextDesign && r.textDesignToolStore.isInverted,
      _r$size = r.size,
      m = _r$size.height,
      u = _r$size.width,
      S = r.spritePosition,
      v = r.rotationWRTOutputRotation,
      y = o.measurements.canvasControls.sprite.controlPadding;
  return st.createElement(c.Controls.Container, null, st.createElement(da, {
    onStart: i,
    onDrag: n,
    onStop: l,
    rotation: v,
    position: S
  }, st.createElement(c.Controls.Sprite, {
    "data-test": b.Sprite,
    onDoubleClick: s,
    height: m,
    width: u
  }, a && st.createElement(Pn, null) || null, h && st.createElement(Dn, null) || null, st.createElement(yn, null), st.createElement(c.Controls.RotateHandle, {
    x: u / 2 + y / 2
  }, st.createElement(Mn, null)))), st.createElement(bo, null));
});
import zt from "react";
import W from "react";
import Xo, { css as ve } from "styled-components";

var $o = c.Crop.GridLine,
    fa = c.Crop.Mask,
    xo = k.Draggable,
    Mt = 3,
    ua = Xo(Pt)(_templateObject68(), Mt, Mt),
    ga = Xo(Pt)(function (t) {
  var o = t.theme.measurements.canvasControls.corner.touchable.desktop,
      e = o / 4 - t.borderWidth;
  return ve(_templateObject69(), e - o, Mt);
}),
    va = Xo(Pt)(function (t) {
  var o = t.theme.measurements.canvasControls.corner.touchable.desktop,
      e = o / 4 - t.borderWidth;
  return ve(_templateObject70(), e - o, e - o);
}),
    ba = Xo(Pt)(function (t) {
  var o = t.theme.measurements.canvasControls.corner.touchable.desktop,
      e = o / 4 - t.borderWidth;
  return ve(_templateObject71(), e - o, Mt);
}),
    xa = function xa(_ref63) {
  var t = _ref63.transformTool;

  var o = t.leftTopRespectFlip,
      e = t.leftBottomRespectFlip,
      r = t.rightTopRespectFlip,
      n = t.rightBottomRespectFlip,
      _t$cropMaskSize = t.cropMaskSize,
      i = _t$cropMaskSize.height,
      l = _t$cropMaskSize.width,
      s = t.maxCropMaskSize,
      p = t.defaultCropMaskPosition,
      a = t.isFlippedHorizontal,
      h = t.isFlippedVertical,
      m = s.width / 2,
      u = s.height / 2,
      S = x(x({}, s), {
    left: p.x,
    top: p.y
  }),
      v = {
    height: i,
    width: l
  },
      y = t.isDragMode ? {
    transition: "unset"
  } : {},
      L = function L(T) {
    return a ? m * 2 - T : T;
  },
      A = function A(T) {
    return h ? u * 2 - T : T;
  },
      H = function H(T, C, w) {
    var Yt = L(T),
        To = A(C);

    switch (ha.getFlippedEdgeIndex(w, a, h)) {
      case 0:
        t.onLeftTop({
          x: Yt,
          y: To
        });
        break;

      case 1:
        t.onLeftBottom({
          x: Yt,
          y: To
        });
        break;

      case 2:
        t.onRightTop({
          x: Yt,
          y: To
        });
        break;

      case 3:
        t.onRightBottom({
          x: Yt,
          y: To
        });
        break;
    }
  },
      F = function F(T, C, w) {
    t.setDragMode(!0), t.clickableCanvas(!1), H(T, C, w);
  },
      V = function V(T, C, w) {
    H(T, C, w);
  },
      R = function R(T, C, w) {
    t.setDragMode(!1), H(T, C, w), t.clickableCanvas(!0), t.addLocalSnapshot();
  },
      lo = function lo(T, _ref64) {
    var C = _ref64.x,
        w = _ref64.y;
    F(C, w, 0);
  },
      ko = function ko(T, _ref65) {
    var C = _ref65.x,
        w = _ref65.y;
    V(C, w, 0);
  },
      yo = function yo(T, _ref66) {
    var C = _ref66.x,
        w = _ref66.y;
    R(C, w, 0);
  },
      po = function po(T, _ref67) {
    var C = _ref67.x,
        w = _ref67.y;
    F(C, w, 1);
  },
      Yo = function Yo(T, _ref68) {
    var C = _ref68.x,
        w = _ref68.y;
    V(C, w, 1);
  },
      co = function co(T, _ref69) {
    var C = _ref69.x,
        w = _ref69.y;
    R(C, w, 1);
  },
      So = function So(T, _ref70) {
    var C = _ref70.x,
        w = _ref70.y;
    F(C, w, 2);
  },
      Do = function Do(T, _ref71) {
    var C = _ref71.x,
        w = _ref71.y;
    V(C, w, 2);
  },
      ti = function ti(T, _ref72) {
    var C = _ref72.x,
        w = _ref72.y;
    R(C, w, 2);
  },
      oi = function oi(T, _ref73) {
    var C = _ref73.x,
        w = _ref73.y;
    F(C, w, 3);
  },
      ei = function ei(T, _ref74) {
    var C = _ref74.x,
        w = _ref74.y;
    V(C, w, 3);
  },
      ri = function ri(T, _ref75) {
    var C = _ref75.x,
        w = _ref75.y;
    R(C, w, 3);
  },
      Jo = function Jo(T, C) {
    var w = L(T + l / 2) - l / 2,
        Yt = A(C + i / 2) - i / 2;
    t.changePosition({
      x: w,
      y: Yt
    });
  },
      ni = function ni(T, _ref76) {
    var C = _ref76.x,
        w = _ref76.y;
    t.setDragMode(!0), t.clickableCanvas(!1), Jo(C, w);
  },
      ii = function ii(T, _ref77) {
    var C = _ref77.x,
        w = _ref77.y;
    Jo(C, w);
  },
      si = function si(T, _ref78) {
    var C = _ref78.x,
        w = _ref78.y;
    t.setDragMode(!1), Jo(C, w), t.clickableCanvas(!0), t.addLocalSnapshot();
  };

  return W.createElement("div", {
    style: x(x({}, S), {
      position: "absolute"
    })
  }, W.createElement(xo, {
    bounds: "parent",
    position: o,
    onStart: ni,
    onDrag: ii,
    onStop: si
  }, W.createElement(fa, {
    style: x(x({}, v), y)
  })), W.createElement($o, {
    style: x({
      left: o.x + l / 3,
      top: o.y,
      height: i,
      width: 1
    }, y)
  }), W.createElement($o, {
    style: x({
      left: o.x + l / 3 * 2,
      top: o.y,
      height: i,
      width: 1
    }, y)
  }), W.createElement($o, {
    style: x({
      left: o.x,
      top: o.y + i / 3,
      height: 1,
      width: l
    }, y)
  }), W.createElement($o, {
    style: x({
      left: o.x,
      top: o.y + i / 3 * 2,
      height: 1,
      width: l
    }, y)
  }), W.createElement(xo, {
    bounds: "parent",
    position: x({}, o),
    onStart: lo,
    onDrag: ko,
    onStop: yo
  }, W.createElement(ua, {
    "data-test": b.CropTopLeft,
    vertical: "top",
    horizontal: "left",
    borderWidth: Mt,
    style: y
  })), W.createElement(xo, {
    bounds: "parent",
    position: e,
    onStart: po,
    onDrag: Yo,
    onStop: co
  }, W.createElement(ba, {
    "data-test": b.CropBottomLeft,
    vertical: "bottom",
    horizontal: "left",
    borderWidth: Mt,
    style: y
  })), W.createElement(xo, {
    bounds: "parent",
    position: r,
    onStart: So,
    onDrag: Do,
    onStop: ti
  }, W.createElement(ga, {
    "data-test": b.CropTopRight,
    vertical: "top",
    horizontal: "right",
    borderWidth: Mt,
    style: y
  })), W.createElement(xo, {
    bounds: "parent",
    position: n,
    onStart: oi,
    onDrag: ei,
    onStop: ri
  }, W.createElement(va, {
    "data-test": b.CropBottomRight,
    vertical: "bottom",
    horizontal: "right",
    borderWidth: Mt,
    style: y
  })));
},
    En = g("transformTool")(d(xa));

import jt from "react";
import Co from "styled-components";
import at from "react";
import Go, { css as Hn } from "styled-components";

var On = Go.div(_templateObject72(), function (t) {
  return t.isVisible && Hn(_templateObject73());
}),
    Ca = Go.div(_templateObject74()),
    wa = Go.div(_templateObject75(), function (t) {
  return t.theme.foreground;
}, function (t) {
  return t.isVisible && Hn(_templateObject76());
}),
    ka = Go.div(_templateObject77()),
    Fn =
/*#__PURE__*/
function (_at$Component) {
  _inherits(Fn, _at$Component);

  function Fn() {
    var _this9;

    _classCallCheck(this, Fn);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Fn).apply(this, arguments));
    _this9.SLIDER_WIDTH = 213;
    _this9.MAX_ROTATION = 45;
    _this9.DEGREES_PER_PIXEL = _this9.MAX_ROTATION * 2 / _this9.SLIDER_WIDTH;

    _this9.drag = function (o, _ref79) {
      var e = _ref79.x;
      var _this9$transformTool$ = _this9.transformTool.rotateFlipState,
          r = _this9$transformTool$.flipHorizontally,
          n = _this9$transformTool$.flipVertically;
      r !== n && (e *= -1);
      var i = _this9.transformTool.defaultAngle - e * _this9.DEGREES_PER_PIXEL,
          l = Math.min(_this9.MAX_ROTATION, Math.max(i, _this9.MAX_ROTATION * -1));

      _this9.transformTool.setRotation(parseInt("".concat(l), 10));
    };

    _this9.stop = function () {
      _this9.transformTool.setDefaultAngle(_this9.transformTool.rotationInDegrees), _this9.transformTool.addLocalSnapshot();
    };

    return _this9;
  }

  _createClass(Fn, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          o = _this$props2.config,
          e = _this$props2.canvasWidth,
          r = _this$props2.transformTool,
          _this$transformTool$r = this.transformTool.rotateFlipState,
          n = _this$transformTool$r.flipHorizontally,
          i = _this$transformTool$r.flipVertically,
          l = !o.isLayoutAdvanced || o.isLayoutAdvanced && e > o.measurements.canvas.transform.minSliderWidth,
          s = !o.isLayoutAdvanced || o.isLayoutAdvanced && e > o.measurements.canvas.transform.minValueWidth,
          p = this.transformTool.rotationInDegrees - this.transformTool.defaultAngle,
          a = n === i ? p * -1 : p,
          h = n !== i ? r.rotationInDegrees * -1 : r.rotationInDegrees;
      return at.createElement(Ca, {
        "data-test": b.RotateSlider
      }, at.createElement(k.Draggable, {
        axis: "x",
        position: {
          x: 0,
          y: 0
        },
        onStart: this.drag,
        onDrag: this.drag,
        onStop: this.stop,
        updateOnPosition: !0,
        disabled: !l
      }, at.createElement(ka, null, at.createElement(On, {
        isVisible: l
      }, at.createElement(M.dots, {
        width: 90,
        height: 15,
        x: a
      })), at.createElement(wa, {
        isVisible: s
      }, h, "\xB0"), at.createElement(On, {
        isVisible: l
      }, at.createElement(M.dots, {
        width: 90,
        height: 15,
        x: a
      })))));
    }
  }, {
    key: "transformTool",
    get: function get() {
      return this.props.transformTool;
    }
  }]);

  return Fn;
}(at.Component),
    Wn = g("transformTool", "config")(d(Fn));

var ya = Co(M.rotate)(_templateObject78()),
    Sa = Co(M.rotate)(_templateObject79()),
    Da = Co(M.flipHorizontal)(_templateObject80()),
    Ta = Co(M.flipVertical)(_templateObject81()),
    Ba = Co.div(_templateObject82()),
    Ma = function Ma(_ref80) {
  var t = _ref80.transformTool,
      o = _ref80.config,
      e = _ref80.custom,
      r = _ref80.canvas;

  var n = t.locale.transformActions,
      i = r.canvasSize.width,
      l = !o.isLayoutAdvanced || o.isLayoutAdvanced && i > o.measurements.canvas.transform.minFlipWidth,
      s = function s(_ref81) {
    var S = _ref81.customButtonKey,
        v = _ref81.onClick,
        y = _ref81.label,
        L = _ref81.icon;
    var A = e.getButton(S);
    return jt.createElement(A, {
      key: y,
      onClick: v,
      label: y,
      ariaLabel: y,
      icon: L,
      style: {
        margin: "0 5px"
      }
    });
  },
      p = s({
    label: n.buttonFlipHorizontal,
    icon: jt.createElement(Da, null),
    onClick: function onClick() {
      t.flipHorizontally();
    },
    customButtonKey: "transformActionFlipHorizontal"
  }),
      a = s({
    label: n.buttonFlipVertical,
    icon: jt.createElement(Ta, null),
    onClick: function onClick() {
      t.flipVertically();
    },
    customButtonKey: "transformActionFlipVertical"
  }),
      h = s({
    label: n.buttonRotateClockwise,
    icon: jt.createElement(ya, null),
    onClick: t.rotateClockwise,
    customButtonKey: "transformActionRotateClockwise"
  }),
      m = s({
    label: n.buttonRotateAntiClockwise,
    icon: jt.createElement(Sa, null),
    onClick: t.rotateAntiClockwise,
    customButtonKey: "transformActionRotateAntiClockwise"
  }),
      u = o.isLayoutAdvanced ? {
    transform: "rotate(180deg)"
  } : {};

  return jt.createElement(Ba, {
    style: u,
    "data-test": b.FlipRotateControls
  }, t.config.enableFlip && l && p || null, t.config.enableFlip && l && a || null, t.config.enableRotation && jt.createElement(Wn, {
    canvasWidth: i
  }) || null, t.config.enableRotation && m || null, t.config.enableRotation && h || null);
},
    be = g("transformTool", "config", "custom", "canvas")(d(Ma));

var za = c.Bar.Index,
    jo = c.Crop.Backdrop,
    La = function La(_ref82) {
  var t = _ref82.transformTool,
      o = _ref82.canvas,
      e = _ref82.config;
  var r = t.leftTopRespectFlip,
      n = t.leftBottomRespectFlip,
      i = t.rightTopRespectFlip,
      l = t.cropMaskSize.height,
      _o$canvasSize = o.canvasSize,
      s = _o$canvasSize.height,
      p = _o$canvasSize.width,
      a = t.defaultCropMaskPosition,
      h = t.isDragMode ? {
    transition: "unset"
  } : {};
  return zt.createElement(c.Controls.Container, null, zt.createElement(jo, {
    style: x({
      left: 0,
      top: 0,
      width: p,
      height: r.y + a.y
    }, h)
  }), zt.createElement(jo, {
    style: x({
      left: 0,
      top: r.y + a.y,
      width: a.x + r.x,
      height: l
    }, h)
  }), zt.createElement(jo, {
    style: x({
      left: i.x + a.x,
      top: i.y + a.y,
      width: p - i.x - a.x,
      height: l
    }, h)
  }), zt.createElement(jo, {
    style: x({
      left: 0,
      top: n.y + a.y,
      width: p,
      height: s - n.y - a.y + e.measurements.basicToolControlBar.controlsBarHeight
    }, h)
  }), zt.createElement(En, null), e.isLayoutAdvanced ? zt.createElement(za, {
    bottom: !0
  }, zt.createElement(be, null)) : null);
},
    Vn = g("transformTool", "canvas", "config")(d(La));

import xe from "react";
import Aa, { css as Pa } from "styled-components";

var Ia = Aa(c.Controls.Container)(_templateObject83(), function (t) {
  return t.activeCursor ? Pa(_templateObject84()) : "";
}, function (t) {
  return t.theme.measurements.zIndex.canvas.crop.dragImage;
}),
    Nn =
/*#__PURE__*/
function (_xe$Component) {
  _inherits(Nn, _xe$Component);

  function Nn(o) {
    var _this10;

    _classCallCheck(this, Nn);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(Nn).call(this, o));
    _this10.INITIAL_POSITION = {
      x: void 0,
      y: void 0
    };
    _this10.state = x(x({}, _this10.INITIAL_POSITION), {
      isDragging: !1
    });
    _this10.containerRef = null;

    _this10.getCursorCoordinates = function (o) {
      var e = 0,
          r = 0;

      if (o.type.indexOf("touch") !== -1) {
        var s = o;
        if (!s.touches.length) return _this10.INITIAL_POSITION;
        e = s.touches[0].clientX, r = s.touches[0].clientY;
      } else {
        var _s6 = o;
        e = _s6.clientX, r = _s6.clientY;
      }

      var n = _this10.containerRef.current.getBoundingClientRect(),
          i = e - n.left,
          l = r - n.top;

      return {
        x: i,
        y: l
      };
    };

    _this10.move = function (o) {
      if (_this10.scale.canDrag) {
        var _this10$getCursorCoor = _this10.getCursorCoordinates(o),
            e = _this10$getCursorCoor.x,
            r = _this10$getCursorCoor.y;

        if (e !== void 0 && r !== void 0 && _this10.state.isDragging) {
          var n = {
            x: _this10.state.x - e,
            y: _this10.state.y - r
          };

          _this10.scale.setOffset(n);
        }
      }
    };

    _this10.touchDrag = function (o) {
      if (_this10.scale.canDrag) {
        var _this10$getCursorCoor2 = _this10.getCursorCoordinates(o),
            e = _this10$getCursorCoor2.x,
            r = _this10$getCursorCoor2.y;

        e !== void 0 && r !== void 0 && _this10.setState({
          x: e,
          y: r,
          isDragging: !0
        });
      }
    };

    _this10.drag = function (o) {
      o.preventDefault(), _this10.touchDrag(o);
    };

    _this10.stop = function () {
      _this10.scale.canDrag && (_this10.scale.savePosition(), _this10.setState(x(x({}, _this10.INITIAL_POSITION), {
        isDragging: !1
      })));
    };

    _this10.touchEnd = function (o) {
      o.preventDefault(), o.stopPropagation();
      var _this10$state = _this10.state,
          e = _this10$state.x,
          r = _this10$state.y;
      e && r && _this10.setState(x(x({}, _this10.INITIAL_POSITION), {
        isDragging: !1
      }));
    };

    _this10.containerRef = xe.createRef();
    return _this10;
  }

  _createClass(Nn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mouseup", this.stop, !1), document.addEventListener("touchend", this.stop, {
        passive: !0
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mouseup", this.stop, !1), document.removeEventListener("touchend", this.stop, !1);
    }
  }, {
    key: "render",
    value: function render() {
      return xe.createElement(Ia, {
        ref: this.containerRef,
        onMouseMove: this.move,
        onTouchMove: this.move,
        onMouseDown: this.drag,
        onTouchStart: this.touchDrag,
        onMouseUp: this.stop,
        onTouchEnd: this.touchEnd,
        activeCursor: this.scale.canDrag
      });
    }
  }, {
    key: "scale",
    get: function get() {
      return this.props.scale;
    }
  }]);

  return Nn;
}(xe.Component),
    Un = g("scale")(d(Nn));

var Kn = d(function (_ref83) {
  var t = _ref83.children;

  var o = Ea(null),
      _j4 = j(),
      e = _j4.active,
      r = _j4.sprite,
      n = _j4.canvas,
      i = function i() {
    switch (e.tool) {
      case I.FOCUS:
        return Zt.createElement(xn, null);

      case I.TEXT:
      case I.TEXT_DESIGN:
      case I.STICKER:
        return Zt.createElement(In, null);

      case I.BRUSH:
        return Zt.createElement(gn, null);

      case I.TRANSFORM:
        return Zt.createElement(Vn, null);

      default:
        return Zt.createElement(c.Controls.Container, null, Zt.createElement(Un, null));
    }
  },
      l = function l(a) {
    if (a.preventDefault(), a.stopPropagation(), n.isCanvasClickable) {
      var h = a.clientX,
          m = a.clientY;

      if (a.type.indexOf("touch") !== -1) {
        var y = a;
        if (!y.touches.length) return;
        h = y.touches[0].clientX, m = y.touches[0].clientY;
      }

      var u = o.current.getBoundingClientRect(),
          S = h - u.left,
          v = m - u.top;
      n.getContainersAtPreviewPoint({
        x: S,
        y: v
      });
    }
  },
      s = function s(a) {
    a.code === "Tab" && r.selectLast();
  },
      p = n.canvasSize;

  return Zt.createElement(c.Controls.Wrapper, {
    "aria-hidden": !0,
    ref: o,
    onClick: l,
    onKeyDown: s,
    height: p.height,
    width: p.width
  }, t, i());
});
import we from "react";
import ke, { css as Xn } from "styled-components";
import Ha from "react";
import Oa from "styled-components";

var Fa = Oa.div(_templateObject85(), function (_ref84) {
  var t = _ref84.isVisible;
  return t ? "block" : "none";
}, function (t) {
  return t.theme.measurements.zIndex.canvas.snappingGuide;
}),
    Wa = function Wa(_ref85) {
  var t = _ref85.isVisible,
      o = _ref85.className;
  return Ha.createElement(Fa, {
    isVisible: t,
    className: o
  });
},
    Ce = Wa;

var Va = ke(Ce)(_templateObject86(), function (t) {
  return t.theme.snapping.positionGuideColor;
}, function (t) {
  return t.direction === "horizontal" ? Xn(_templateObject87(), function () {
    return t.position;
  }) : Xn(_templateObject88(), function () {
    return t.position;
  });
}),
    Na = ke(Ce)(_templateObject89(), function (t) {
  return t.theme.snapping.rotationGuideColor;
}, function (_ref86) {
  var t = _ref86.position;
  return t.x;
}, function (_ref87) {
  var t = _ref87.position;
  return t.y;
}, function (_ref88) {
  var t = _ref88.rotation;
  return t;
}),
    Ua = ke.div(_templateObject90(), function (_ref89) {
  var t = _ref89.width;
  return t;
}, function (_ref90) {
  var t = _ref90.height;
  return t;
}, function (_ref91) {
  var t = _ref91.top;
  return t;
}, function (_ref92) {
  var t = _ref92.left;
  return t;
}),
    Ka = function Ka(_ref93) {
  var t = _ref93.snapping,
      o = _ref93.editor;

  var _o$getPreviewSize = o.getPreviewSize(),
      e = _o$getPreviewSize.width,
      r = _o$getPreviewSize.height,
      _t$previewTopLeftPosi = t.previewTopLeftPosition,
      n = _t$previewTopLeftPosi.x,
      i = _t$previewTopLeftPosi.y,
      l = t.positionGuides.map(function (_ref94, m) {
    var p = _ref94.direction,
        a = _ref94.value,
        h = _ref94.isVisible;
    return we.createElement(Va, {
      key: "positionGuide-".concat(m),
      direction: p,
      position: a,
      isVisible: h
    });
  }),
      s = t.rotationGuides.find(function (_ref95) {
    var p = _ref95.isVisible;
    return p;
  });

  return we.createElement(Ua, {
    width: e,
    height: r,
    left: n,
    top: i
  }, l, we.createElement(Na, {
    key: "rotationGuide",
    rotation: s ? s.value : 0,
    position: s ? s.position : {
      x: 0,
      y: 0
    },
    isVisible: !!s
  }));
},
    $n = g("snapping", "editor")(d(Ka));

import Xa from "react";
import $a from "styled-components";

var Ga = $a.img(_templateObject91()),
    Gn = function Gn() {
  return Xa.createElement(Ga, {
    alt: "watermark",
    "data-test": b.Watermark,
    src: "data:image/png;base64,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"
  });
};

import Lt from "react";

var ye = 24,
    jn =
/*#__PURE__*/
function (_Lt$Component) {
  _inherits(jn, _Lt$Component);

  function jn(o) {
    var _this11;

    _classCallCheck(this, jn);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(jn).call(this, o));

    _this11.init = function () {
      navigator.mediaDevices && navigator.mediaDevices.getUserMedia ? navigator.mediaDevices.getUserMedia({
        video: !0
      }).then(function (o) {
        _this11.video.srcObject = o;
      }).catch(function () {
        _this11.props.modal.showActionModal({
          type: wo.ERROR,
          identifier: "webcamUnavailable",
          error: "Webcam not supported",
          handleConfirm: function handleConfirm() {
            _this11.props.active.selectWebcam(!1);
          }
        });
      }) : _this11.props.modal.showActionModal({
        type: wo.ERROR,
        identifier: "webcamUnavailable",
        error: "Webcam not supported",
        handleConfirm: function handleConfirm() {
          _this11.props.active.selectWebcam(!1);
        }
      });
    };

    _this11.stop = function () {
      var o = _this11.props.active;
      _this11.video.srcObject.getTracks().forEach(function (n) {
        n.stop();
      }), _this11.video.srcObject = null, o.selectWebcam(!1);
    };

    _this11.captureAndCloseWebcam = function () {
      _this11.canvas.width = _this11.video.videoWidth, _this11.canvas.height = _this11.video.videoHeight, _this11.canvas.getContext("2d").drawImage(_this11.video, 0, 0), _this11.props.active.newImage(_this11.canvas.toDataURL("image/webp")), _this11.stop();
    };

    _this11.videoRef = Lt.createRef();
    return _this11;
  }

  _createClass(jn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.canvas = document.createElement("canvas"), this.video = this.videoRef.current, this.init();
    }
  }, {
    key: "render",
    value: function render() {
      var o = this.props.editor,
          _o$getPreviewSize2 = o.getPreviewSize(),
          e = _o$getPreviewSize2.height,
          r = _o$getPreviewSize2.width,
          n = o.configStore.measurements,
          i = this.props.canvas.canvasSize.height,
          l = (i - e) / 2,
          s = l < ye + n.buttons.float.size ? i - ye * 2 - n.buttons.float.size / 2 : i - l + ye,
          p = this.props.active.webcamLabel;

      return Lt.createElement(c.Wrapper, null, Lt.createElement(c.Bar.Index, {
        transparentBackgound: !0,
        style: {
          justifyContent: "flex-end"
        }
      }, Lt.createElement(c.Bar.ButtonGroup, null, Lt.createElement(Po, {
        ariaLabel: p,
        onClick: this.stop
      }, p))), Lt.createElement(c.Webcam, {
        style: {
          height: e,
          width: r
        },
        autoPlay: !0,
        ref: this.videoRef
      }), Lt.createElement(c.Button.Float, {
        ariaLabel: "Click and Save",
        style: {
          top: s
        },
        onClick: this.captureAndCloseWebcam
      }));
    }
  }]);

  return jn;
}(Lt.Component),
    Zn = g("active", "canvas", "modal", "editor")(d(jn));

import Yn, { Component as ja } from "react";

var Jn =
/*#__PURE__*/
function (_ja) {
  _inherits(Jn, _ja);

  function Jn(o) {
    var _this12;

    _classCallCheck(this, Jn);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(Jn).call(this, o));
    _this12.wrapperElementRef = null;
    _this12.timeout = null;

    _this12.updateDimensions = function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      o ? (clearTimeout(_this12.timeout), _this12.timeout = setTimeout(function () {
        _this12.update(o);
      }, 100)) : _this12.update(o);
    };

    _this12.update = function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var e = _this12.wrapperElementRef.current;

      _this12.props.canvas.saveDimensions({
        width: e && e.clientWidth || 0,
        height: e && e.clientHeight || 0,
        render: o
      });
    };

    _this12.wrapperElementRef = Yn.createRef(), _this12.resizeObserver = new Za(function () {
      _this12.updateDimensions(!1);
    });
    return _this12;
  }

  _createClass(Jn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this13 = this;

      this.updateDimensions(!1), window.addEventListener("resize", function () {
        return _this13.updateDimensions(!0);
      }), this.wrapperElementRef.current && this.resizeObserver.observe(this.wrapperElementRef.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this14 = this;

      window.removeEventListener("resize", function () {
        return _this14.updateDimensions(!0);
      }), this.timeout && clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      return Yn.createElement(c.Container, {
        "data-test": b.CanvasContainer,
        ref: this.wrapperElementRef
      }, this.props.children);
    }
  }]);

  return Jn;
}(ja),
    qn = g("canvas")(d(Jn));

var qa = d(function () {
  var t = Ya(null),
      _j5 = j(),
      o = _j5.canvas,
      e = _j5.active,
      r = _j5.config;

  Ja(function () {
    var i = t.current;
    o.setCanvasElement(i);
  }, []);
  var n = r.licenseChecker;
  return so.createElement(qn, null, n && n.isWhiteLabel() ? null : so.createElement(Gn, null), e.isWebcam ? so.createElement(Zn, null) : null, so.createElement(c.Element, {
    ref: t,
    "aria-label": "Canvas",
    "data-test": b.Canvas
  }), so.createElement(Kn, null, so.createElement($n, null)));
});
import At from "react";

var Ra = function Ra(_ref96) {
  var t = _ref96.modal,
      o = _ref96.textTool,
      e = _ref96.textDesignTool,
      r = _ref96.config,
      n = _ref96.custom;
  var i = t.type,
      l = t.identifier,
      s = t.isVisible,
      p = t.modalProps,
      a = t.positionOffset,
      h = p.headerLabel,
      m = p.bodyLabel,
      u = p.confirmLabel,
      S = p.dismissLabel,
      v = p.handleClose,
      y = p.handleConfirm,
      L = p.handleDismiss,
      A = n.getDialog();
  if (i === wo.INFO) return At.createElement(k.InfoModal, {
    headerLabel: h,
    bodyLabel: m
  }, At.createElement(A, {
    type: i,
    isVisible: s,
    identifier: l,
    position: a,
    handleClose: v,
    headerLabel: h,
    bodyLabel: m
  }));

  if (i === wo.TEXT_EDIT) {
    var _o$locale$canvasContr = o.locale.canvasControls,
        H = _o$locale$canvasContr.buttonSave,
        F = _o$locale$canvasContr.buttonClose,
        V = {
      type: i,
      isVisible: t.isVisible,
      confirmLabel: H,
      dismissLabel: F,
      headerLabel: o.locale.canvasControls.inputText,
      maxLength: r.config.text.maxCharacterLimit
    };
    if (o.isTextSelected) return At.createElement(k.TextEditModal, x(x({}, V), {
      defaultText: Qa.defaultText(),
      handleConfirm: o.changeText,
      handleDismiss: o.setEditMode,
      text: o.text
    }), At.createElement(A, {
      type: i,
      isVisible: s,
      identifier: l,
      position: a,
      handleClose: v,
      confirmLabel: H,
      dismissLabel: F,
      headerLabel: o.locale.canvasControls.inputText
    }));
    if (e.isTextDesignSelected) return At.createElement(k.TextEditModal, x(x({}, V), {
      defaultText: _a.defaultText(),
      handleConfirm: e.changeText,
      handleDismiss: e.setEditMode,
      text: e.text
    }), At.createElement(A, {
      type: i,
      isVisible: s,
      identifier: l,
      position: a,
      handleClose: v,
      confirmLabel: H,
      dismissLabel: F,
      headerLabel: o.locale.canvasControls.inputText
    }));
  }

  return At.createElement(k.ActionModal, {
    type: i,
    headerLabel: h,
    bodyLabel: m,
    confirmLabel: u,
    dismissLabel: S,
    handleClose: v,
    handleConfirm: y,
    handleDismiss: L
  }, At.createElement(A, {
    type: i,
    isVisible: s,
    identifier: l,
    position: a,
    confirmLabel: u,
    dismissLabel: S,
    headerLabel: h,
    bodyLabel: m,
    handleClose: v
  }));
},
    tl = g("textTool", "textDesignTool", "modal", "config", "custom")(d(Ra));

import ao from "react";
import _n from "styled-components";
import Zo from "react";
import ol from "styled-components";

var el = ol.div(_templateObject92()),
    Qn =
/*#__PURE__*/
function (_Zo$Component) {
  _inherits(Qn, _Zo$Component);

  function Qn(o) {
    var _this15;

    _classCallCheck(this, Qn);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(Qn).call(this, o));

    _this15.onChange = function (o) {
      _this15.setState({
        value: o.replace(/[^\d.,-]/g, ""),
        isSubmitted: !1
      });
    };

    _this15.onSubmit = function () {
      var o = _this15.props.getCorrectValue,
          _this15$state = _this15.state,
          e = _this15$state.isSubmitted,
          r = _this15$state.value;
      e || _this15.setState({
        value: o(parseInt(r, 10) || 0).toString(),
        isSubmitted: !0
      });
    };

    _this15.state = {
      isSubmitted: !1,
      value: o.value.toString()
    };
    return _this15;
  }

  _createClass(Qn, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(o) {
      var e = this.props.value;
      o.value !== e && this.setState({
        value: e.toString()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          o = _this$props3.id,
          e = _this$props3.isDisabled,
          r = _this$props3.label,
          n = this.state.value;
      return Zo.createElement(k.Input.Text, {
        id: o,
        value: n,
        isDisabled: e,
        onChange: this.onChange,
        onBlur: this.onSubmit,
        onKeyUp: Be(this.onSubmit)
      }, Zo.createElement(el, null, Zo.createElement(k.Input.Label, {
        label: r,
        htmlFor: o
      })));
    }
  }]);

  return Qn;
}(Zo.Component),
    Se = Qn;

var rl = _n.div(_templateObject93(), function (t) {
  return t.theme.measurements.advancedUIToolControlBar.width;
}),
    nl = _n.span(_templateObject94(), function (t) {
  return t.theme.measurements.fontSystem.body.size;
}, function (t) {
  return t.theme.measurements.fontSystem.body.letterSpacing;
}, function (t) {
  return t.theme.measurements.fontSystem.body.case;
}),
    il = "photoeditorsdk-transformScaleWidth",
    sl = "photoeditorsdk-transformScaleHeight",
    al = function al(_ref97) {
  var _ref97$showLabel = _ref97.showLabel,
      t = _ref97$showLabel === void 0 ? !0 : _ref97$showLabel,
      o = _ref97.label,
      e = _ref97.isDisabled,
      r = _ref97.valueHeight,
      n = _ref97.valueWidth,
      i = _ref97.labelWidth,
      l = _ref97.labelHeight,
      s = _ref97.onSubmitWidth,
      p = _ref97.onSubmitHeight;
  return ao.createElement("div", null, ao.createElement(k.Input.Label, {
    label: o,
    show: t
  }), ao.createElement(rl, null, ao.createElement(Se, {
    id: il,
    value: n,
    getCorrectValue: s,
    label: i,
    isDisabled: e
  }), ao.createElement(nl, null, "x"), ao.createElement(Se, {
    id: sl,
    value: r,
    getCorrectValue: p,
    label: l,
    isDisabled: e
  })));
},
    ll = al;

import ml from "react";
import { useState as pl, useEffect as cl } from "react";

var Rn = function Rn() {
  var _pl = pl([]),
      _pl2 = _slicedToArray(_pl, 2),
      t = _pl2[0],
      o = _pl2[1];

  return cl(function () {
    var e;

    if (typeof window !== void 0 && ((e = window.navigator) == null ? void 0 : e.mediaDevices)) {
      var r = !0,
          n = function n() {
        window.navigator.mediaDevices.enumerateDevices().then(function (i) {
          r && o(i.map(function (_ref98) {
            var l = _ref98.deviceId,
                s = _ref98.groupId,
                p = _ref98.kind,
                a = _ref98.label;
            return {
              deviceId: l,
              groupId: s,
              kind: p,
              label: a
            };
          }));
        }).catch(function () {
          return null;
        });
      };

      return window.navigator.mediaDevices.addEventListener("devicechange", n), n(), function () {
        r = !1, window.navigator.mediaDevices.removeEventListener("devicechange", n);
      };
    }

    return null;
  }, []), t;
};

var k5 = d(function (_ref99) {
  var t = _ref99.tool,
      _ref99$fullWidth = _ref99.fullWidth,
      o = _ref99$fullWidth === void 0 ? !1 : _ref99$fullWidth,
      e = _ref99.icon,
      r = _ref99.label,
      n = _ref99.onClick;

  var _j6 = j(),
      i = _j6.custom;

  if (!Rn().some(function (_ref100) {
    var p = _ref100.kind;
    return p === "videoinput";
  })) return null;
  var s = i.getButton("toolControlBarSecondaryButton");
  return ml.createElement(s, {
    tool: t,
    label: r,
    ariaLabel: r,
    onClick: n,
    fullWidth: o,
    icon: e
  });
});
export { ul as a, dc as b, uc as c, bc as d, wc as e, Sc as f, gl as g, Ro as h, U as i, Me as j, Mo as k, Js as l, k5 as m, _o as n, Jt as o, j as p, or as q, qa as r, Bl as s, ll as t, tl as u, be as v, Gs as w, Al as x, _m as y, Rm as z, M as A, td as B };